export class Anims {
  static homePageTitle = {
    v: "5.6.2",
    fr: 29.9700012207031,
    ip: 0,
    op: 123.000005009893,
    w: 1080,
    h: 1920,
    nm: "LOGO CALENDRIER",
    ddd: 1,
    assets: [
      {
        id: "comp_0",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Calque de forme 12",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [775, 1493.5, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [45, 102], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [56, -531], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -42.0000017106951,
            op: 1737.00007074946,
            st: -42.0000017106951,
            bm: 0
          },
          {
            ddd: 0,
            ind: 2,
            ty: 5,
            nm: "D",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 32,
                    s: [408.201, 923, 0],
                    to: [8.917, 0, 0],
                    ti: [-8.917, 0, 0]
                  },
                  { t: 48.0000019550801, s: [461.701, 923, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [723, 687.5],
                      ps: [0, 0],
                      s: 120,
                      f: "Belleville-Regular",
                      t: "D",
                      j: 2,
                      tr: 0,
                      lh: 144,
                      ls: 0,
                      fc: [1, 1, 1]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: -6.00000024438501,
            op: 1773.00007221577,
            st: -6.00000024438501,
            bm: 0
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Calque de forme 11",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [806, 1493.5, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [45, 102], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [56, -531], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -42.0000017106951,
            op: 1737.00007074946,
            st: -42.0000017106951,
            bm: 0
          },
          {
            ddd: 0,
            ind: 4,
            ty: 5,
            nm: "E",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 28,
                    s: [436.279, 923, 0],
                    to: [8.917, 0, 0],
                    ti: [-8.917, 0, 0]
                  },
                  { t: 44.0000017921567, s: [489.779, 923, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [723, 687.5],
                      ps: [0, 0],
                      s: 120,
                      f: "Belleville-Regular",
                      t: "E",
                      j: 2,
                      tr: 0,
                      lh: 144,
                      ls: 0,
                      fc: [1, 1, 1]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: -10.0000004073083,
            op: 1769.00007205285,
            st: -10.0000004073083,
            bm: 0
          },
          {
            ddd: 0,
            ind: 5,
            ty: 4,
            nm: "Calque de forme 10",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [516, 960, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [45, 102], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [56, -531], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -32.0000013033867,
            op: 1747.00007115677,
            st: -32.0000013033867,
            bm: 0
          },
          {
            ddd: 0,
            ind: 6,
            ty: 5,
            nm: "L",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 12,
                    s: [164.701, 385, 0],
                    to: [5.833, 0, 0],
                    ti: [-5.833, 0, 0]
                  },
                  { t: 27.0000010997325, s: [199.701, 385, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [723, 687.5],
                      ps: [0, 0],
                      s: 120,
                      f: "Belleville-Regular",
                      t: "L",
                      j: 2,
                      tr: 0,
                      lh: 144,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: -28.0000011404634,
            op: 1751.00007131969,
            st: -28.0000011404634,
            bm: 0
          },
          {
            ddd: 0,
            ind: 7,
            ty: 4,
            nm: "Calque de forme 9",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [540, 960, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [45, 102], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [56, -531], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -32.0000013033867,
            op: 1747.00007115677,
            st: -32.0000013033867,
            bm: 0
          },
          {
            ddd: 0,
            ind: 8,
            ty: 5,
            nm: "e",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 8,
                    s: [189.299, 385, 0],
                    to: [5.833, 0, 0],
                    ti: [-5.833, 0, 0]
                  },
                  { t: 23.0000009368092, s: [224.299, 385, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [723, 687.5],
                      ps: [0, 0],
                      s: 120,
                      f: "Belleville-Regular",
                      t: "e",
                      j: 2,
                      tr: 0,
                      lh: 144,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: -32.0000013033867,
            op: 1747.00007115677,
            st: -32.0000013033867,
            bm: 0
          },
          {
            ddd: 0,
            ind: 9,
            ty: 5,
            nm: "- 2",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [513, 752, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            hasMask: true,
            masksProperties: [
              {
                inv: false,
                mode: "a",
                pt: {
                  a: 1,
                  k: [
                    {
                      i: { x: 0, y: 1 },
                      o: { x: 0.333, y: 0 },
                      t: 26,
                      s: [
                        {
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          v: [
                            [1, 105],
                            [-10.5, 105],
                            [-10.5, 161.5],
                            [1, 161.5]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 40.0000016292334,
                      s: [
                        {
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          v: [
                            [71, 105],
                            [-10.5, 105],
                            [-10.5, 161.5],
                            [71, 161.5]
                          ],
                          c: true
                        }
                      ]
                    }
                  ],
                  ix: 1
                },
                o: { a: 0, k: 100, ix: 3 },
                x: { a: 0, k: 0, ix: 4 },
                nm: "Masque 1"
              }
            ],
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [723, 687.5],
                      ps: [0, 0],
                      s: 360,
                      f: "Belleville-Regular",
                      t: "-",
                      j: 0,
                      tr: 0,
                      lh: 432,
                      ls: 0,
                      fc: [1, 1, 1]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          }
        ]
      },
      {
        id: "comp_1",
        layers: [
          {
            ddd: 1,
            ind: 1,
            ty: 4,
            nm: "I 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 29,
                    s: [-82]
                  },
                  { t: 42.0000017106951, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [466, 754, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [37.08, 251.999],
                          [37.08, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "I",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "I",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 29.0000011811942,
            op: 1779.00007246016,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 3,
            ty: 4,
            nm: "E 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 31,
                    s: [-82]
                  },
                  { t: 44.0000017921567, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [508.479, 754, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [68.4, 146.879],
                          [68.4, 115.559],
                          [37.08, 115.559],
                          [37.08, 31.319],
                          [68.4, 31.319],
                          [68.4, -0.361],
                          [5.4, -0.361],
                          [5.4, 251.999],
                          [68.4, 251.999],
                          [68.4, 220.319],
                          [37.08, 220.319],
                          [37.08, 146.879]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "E",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "E",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 31.0000012626559,
            op: 1781.00007254162,
            st: 2.00000008146167,
            bm: 0
          },
          {
            ddd: 1,
            ind: 5,
            ty: 4,
            nm: "R 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 33,
                    s: [-82]
                  },
                  { t: 46.0000018736184, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [582.274, 754, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-2.16, 6.002],
                          [0, 6.964],
                          [0, 0],
                          [1.44, 5.04],
                          [3.358, 3.842],
                          [5.276, 2.16],
                          [7.92, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [5.276, -3.836],
                          [2.16, -5.996],
                          [0, 0],
                          [0, -5.76],
                          [-1.44, -5.04],
                          [-3.364, -3.836],
                          [-5.282, -2.16],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [37.08, 251.999],
                          [37.08, 146.879],
                          [44.64, 146.879],
                          [57.6, 251.999],
                          [89.28, 251.999],
                          [74.88, 138.959],
                          [86.04, 124.199],
                          [89.28, 104.759],
                          [89.28, 41.759],
                          [87.12, 25.559],
                          [79.92, 12.239],
                          [66.96, 3.239],
                          [47.16, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "R",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.44, -2.036],
                          [0, -2.88],
                          [0, 0],
                          [1.44, -2.036],
                          [4.078, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [4.078, 0],
                          [1.44, 2.042],
                          [0, 0],
                          [0, 2.88],
                          [-1.44, 2.042],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [47.16, 31.319],
                          [55.44, 34.379],
                          [57.6, 41.759],
                          [57.6, 104.759],
                          [55.44, 112.139],
                          [47.16, 115.199],
                          [37.08, 115.199],
                          [37.08, 31.319]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "R",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "R",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 33.0000013441176,
            op: 1783.00007262308,
            st: 4.00000016292334,
            bm: 0
          }
        ]
      },
      {
        id: "comp_2",
        layers: [
          {
            ddd: 1,
            ind: 1,
            ty: 4,
            nm: "c 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 22,
                    s: [-72.5]
                  },
                  { t: 35.0000014255792, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [304, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-2.042, -1.558],
                          [0, -4.078],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [2.16, 5.4],
                          [3.836, 3.24],
                          [5.04, 1.44],
                          [5.76, 0],
                          [5.158, -1.44],
                          [3.836, -3.24],
                          [2.16, -5.4],
                          [0, -7.92],
                          [0, 0],
                          [-2.16, -5.4],
                          [-3.842, -3.24],
                          [-5.164, -1.44],
                          [-5.76, 0],
                          [-5.04, 1.44],
                          [-3.842, 3.24],
                          [-2.16, 5.4],
                          [0, 7.92],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [2.036, -1.44],
                          [2.88, 0],
                          [2.036, 1.44],
                          [0, 4.084],
                          [0, 0],
                          [-2.042, 1.564],
                          [-2.88, 0]
                        ],
                        o: [
                          [2.036, 1.564],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -7.92],
                          [-2.16, -5.4],
                          [-3.842, -3.24],
                          [-5.04, -1.44],
                          [-5.76, 0],
                          [-5.164, 1.44],
                          [-3.842, 3.24],
                          [-2.16, 5.4],
                          [0, 0],
                          [0, 7.92],
                          [2.16, 5.4],
                          [3.836, 3.24],
                          [5.158, 1.44],
                          [5.76, 0],
                          [5.04, -1.44],
                          [3.836, -3.24],
                          [2.16, -5.4],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 4.084],
                          [-2.042, 1.44],
                          [-2.88, 0],
                          [-2.042, -1.44],
                          [0, 0],
                          [0, -4.078],
                          [2.036, -1.558],
                          [2.88, 0]
                        ],
                        v: [
                          [54.9, 31.859],
                          [57.96, 40.319],
                          [57.96, 71.639],
                          [89.28, 71.639],
                          [89.28, 40.319],
                          [86.04, 20.339],
                          [77.04, 7.379],
                          [63.72, 0.359],
                          [47.52, -1.801],
                          [31.14, 0.359],
                          [17.64, 7.379],
                          [8.64, 20.339],
                          [5.4, 40.319],
                          [5.4, 211.679],
                          [8.64, 231.659],
                          [17.64, 244.619],
                          [31.14, 251.639],
                          [47.52, 253.799],
                          [63.72, 251.639],
                          [77.04, 244.619],
                          [86.04, 231.659],
                          [89.28, 211.679],
                          [89.28, 178.559],
                          [57.96, 178.559],
                          [57.96, 211.679],
                          [54.9, 219.959],
                          [47.52, 222.119],
                          [40.14, 219.959],
                          [37.08, 211.679],
                          [37.08, 40.319],
                          [40.14, 31.859],
                          [47.52, 29.519]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "c",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "c",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 22.0000008960784,
            op: 1779.00007246016,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 3,
            ty: 4,
            nm: "a 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 24,
                    s: [-72.5]
                  },
                  { t: 37.0000015070409, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [398.675, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [41.4, 199.439],
                          [67.68, 199.439],
                          [72, 251.999],
                          [103.68, 251.999],
                          [79.2, -0.001],
                          [29.88, -0.001],
                          [5.4, 251.999],
                          [37.08, 251.999]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "a",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [54.72, 37.439],
                          [65.16, 168.119],
                          [43.92, 168.119]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "a",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "a",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 24.00000097754,
            op: 1781.00007254162,
            st: 2.00000008146167,
            bm: 0
          },
          {
            ddd: 1,
            ind: 5,
            ty: 4,
            nm: "l 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 26,
                    s: [-72.5]
                  },
                  { t: 39.0000015885026, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [507.752, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [68.4, 251.999],
                          [68.4, 220.319],
                          [37.08, 220.319],
                          [37.08, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "l",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "l",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 26.0000010590017,
            op: 1783.00007262308,
            st: 4.00000016292334,
            bm: 0
          },
          {
            ddd: 1,
            ind: 7,
            ty: 4,
            nm: "e 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 28,
                    s: [-72.5]
                  },
                  { t: 41.0000016699642, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [581.548, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [68.4, 146.879],
                          [68.4, 115.559],
                          [37.08, 115.559],
                          [37.08, 31.319],
                          [68.4, 31.319],
                          [68.4, -0.361],
                          [5.4, -0.361],
                          [5.4, 251.999],
                          [68.4, 251.999],
                          [68.4, 220.319],
                          [37.08, 220.319],
                          [37.08, 146.879]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "e",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "e",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 28.0000011404634,
            op: 1785.00007270454,
            st: 6.00000024438501,
            bm: 0
          },
          {
            ddd: 1,
            ind: 9,
            ty: 4,
            nm: "n 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 30,
                    s: [-72.5]
                  },
                  { t: 43.0000017514259, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [655.343, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [61.92, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999],
                          [36.72, 251.999],
                          [37.08, 34.919],
                          [65.52, 251.999],
                          [123.48, 251.999],
                          [123.48, -0.001],
                          [91.8, -0.001],
                          [91.8, 217.079]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "n",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "n",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 30.0000012219251,
            op: 1787.000072786,
            st: 8.00000032584668,
            bm: 0
          },
          {
            ddd: 1,
            ind: 11,
            ty: 4,
            nm: "d 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 32,
                    s: [-72.5]
                  },
                  { t: 45.0000018328876, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [784.218, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [1.44, 5.164],
                          [3.24, 3.842],
                          [5.276, 2.16],
                          [7.92, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-5.282, 2.16],
                          [-3.24, 3.842],
                          [-1.44, 5.164],
                          [0, 5.76],
                          [0, 0]
                        ],
                        o: [
                          [-1.44, -5.158],
                          [-3.24, -3.836],
                          [-5.282, -2.16],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [7.92, 0],
                          [5.276, -2.16],
                          [3.24, -3.836],
                          [1.44, -5.158],
                          [0, 0],
                          [0, -5.76]
                        ],
                        v: [
                          [87.12, 25.739],
                          [80.1, 12.239],
                          [67.32, 3.239],
                          [47.52, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999],
                          [47.52, 251.999],
                          [67.32, 248.759],
                          [80.1, 239.759],
                          [87.12, 226.259],
                          [89.28, 209.879],
                          [89.28, 42.119]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "d",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.44, -2.16],
                          [0, -2.88],
                          [0, 0],
                          [1.44, -2.036],
                          [4.078, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [4.078, 0],
                          [1.44, 2.16],
                          [0, 0],
                          [0, 2.88],
                          [-1.44, 2.042],
                          [0, 0]
                        ],
                        v: [
                          [37.08, 220.319],
                          [37.08, 31.319],
                          [47.52, 31.319],
                          [55.8, 34.559],
                          [57.96, 42.119],
                          [57.96, 209.879],
                          [55.8, 217.259],
                          [47.52, 220.319]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "d",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "d",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 32.0000013033867,
            op: 1789.00007286746,
            st: 10.0000004073083,
            bm: 0
          },
          {
            ddd: 1,
            ind: 13,
            ty: 4,
            nm: "r 2 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              rx: {
                a: 1,
                k: [
                  {
                    i: { x: [0], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 34,
                    s: [-72.5]
                  },
                  { t: 47.0000019143492, s: [0] }
                ],
                ix: 8
              },
              ry: { a: 0, k: 0, ix: 9 },
              rz: { a: 0, k: 0, ix: 10 },
              or: { a: 0, k: [0, 0, 0], ix: 7 },
              p: { a: 0, k: [878.893, 490, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-2.16, 6.002],
                          [0, 6.964],
                          [0, 0],
                          [1.44, 5.04],
                          [3.358, 3.842],
                          [5.276, 2.16],
                          [7.92, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [5.276, -3.836],
                          [2.16, -5.996],
                          [0, 0],
                          [0, -5.76],
                          [-1.44, -5.04],
                          [-3.364, -3.836],
                          [-5.282, -2.16],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [37.08, 251.999],
                          [37.08, 146.879],
                          [44.64, 146.879],
                          [57.6, 251.999],
                          [89.28, 251.999],
                          [74.88, 138.959],
                          [86.04, 124.199],
                          [89.28, 104.759],
                          [89.28, 41.759],
                          [87.12, 25.559],
                          [79.92, 12.239],
                          [66.96, 3.239],
                          [47.16, -0.001],
                          [5.4, -0.001],
                          [5.4, 251.999]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "r",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.44, -2.036],
                          [0, -2.88],
                          [0, 0],
                          [1.44, -2.036],
                          [4.078, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [4.078, 0],
                          [1.44, 2.042],
                          [0, 0],
                          [0, 2.88],
                          [-1.44, 2.042],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [47.16, 31.319],
                          [55.44, 34.379],
                          [57.6, 41.759],
                          [57.6, 104.759],
                          [55.44, 112.139],
                          [47.16, 115.199],
                          [37.08, 115.199],
                          [37.08, 31.319]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "r",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "r",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 34.0000013848484,
            op: 1791.00007294893,
            st: 12.00000048877,
            bm: 0
          }
        ]
      },
      {
        id: "comp_3",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Calque de forme 8",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-2, 977, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 2,
            ty: 5,
            nm: "l",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 42,
                    s: [-157.826, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 61.0000024845809, s: [16.174, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "l",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 25.0000010182709,
            op: 1804.00007347843,
            st: 25.0000010182709,
            bm: 0
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Calque de forme 7",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [70, 977, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 4,
            ty: 5,
            nm: "’",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 39,
                    s: [-104.528, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 58.0000023623884, s: [69.472, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "’",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 22.0000008960784,
            op: 1801.00007335623,
            st: 22.0000008960784,
            bm: 0
          },
          {
            ddd: 0,
            ind: 5,
            ty: 4,
            nm: "Calque de forme 6",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [103, 1017, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 6,
            ty: 5,
            nm: "a",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 36,
                    s: [-34.977, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 57.0000023216576, s: [139.023, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "a",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 19.0000007738859,
            op: 1798.00007323404,
            st: 19.0000007738859,
            bm: 0
          },
          {
            ddd: 0,
            ind: 7,
            ty: 4,
            nm: "Calque de forme 5",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [210, 1017, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 8,
            ty: 5,
            nm: "p",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 33,
                    s: [85.532, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 54.0000021994651, s: [259.532, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "p",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 16.0000006516934,
            op: 1795.00007311185,
            st: 16.0000006516934,
            bm: 0
          },
          {
            ddd: 0,
            ind: 9,
            ty: 4,
            nm: "Calque de forme 4",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [346, 960, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 10,
            ty: 5,
            nm: "r",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 30,
                    s: [201.099, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 51.0000020772726, s: [375.099, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "r",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 13.0000005295009,
            op: 1792.00007298966,
            st: 13.0000005295009,
            bm: 0
          },
          {
            ddd: 0,
            ind: 11,
            ty: 4,
            nm: "Calque de forme 3",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [442, 960, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 12,
            ty: 5,
            nm: "è",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 27,
                    s: [299.51, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 48.0000019550801, s: [473.51, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "è",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 10.0000004073083,
            op: 1789.00007286746,
            st: 10.0000004073083,
            bm: 0
          },
          {
            ddd: 0,
            ind: 13,
            ty: 4,
            nm: "Calque de forme 2",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [545, 960, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [136, 254], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [532, 91], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          },
          {
            ddd: 0,
            ind: 14,
            ty: 5,
            nm: "s",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 24,
                    s: [400.518, 960, 0],
                    to: [29, 0, 0],
                    ti: [-29, 0, 0]
                  },
                  { t: 45.0000018328876, s: [574.518, 960, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      sz: [966.058654785156, 591.999938964844],
                      ps: [0, 0],
                      s: 260,
                      f: "SuperiorTitle-Light",
                      t: "s",
                      j: 2,
                      tr: -25,
                      lh: 312,
                      ls: 0,
                      fc: [0.718, 0.651, 0.29]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 7.00000028511585,
            op: 1786.00007274527,
            st: 7.00000028511585,
            bm: 0
          }
        ]
      }
    ],
    fonts: {
      list: [
        {
          fName: "SuperiorTitle-Light",
          fFamily: "Superior Title",
          fStyle: "Light",
          ascent: 75.798583984375
        },
        {
          fName: "Belleville-Regular",
          fFamily: "Belleville",
          fStyle: "Regular",
          ascent: 70.9996948242188
        }
      ]
    },
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "tiret LE DE tiret",
        refId: "comp_0",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [420, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        w: 1080,
        h: 1920,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 0,
        nm: "ier",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        w: 1080,
        h: 1920,
        ip: 25.0000010182709,
        op: 1775.00007229723,
        st: -4.00000016292334,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: "ier",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 23.0000009368092,
        op: 1773.00007221577,
        st: -6.00000024438501,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 0,
        nm: "ier",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0.145790070295, 0.61960786581, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 21.0000008553475,
        op: 1771.00007213431,
        st: -8.00000032584668,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 0,
        nm: "ier",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0.265743851662, 0.705882370472, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 19.0000007738859,
        op: 1769.00007205285,
        st: -10.0000004073083,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 0,
        nm: "calendr",
        refId: "comp_2",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        w: 1080,
        h: 1920,
        ip: 14.0000005702317,
        op: 1771.00007213431,
        st: -8.00000032584668,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 0,
        nm: "calendr",
        refId: "comp_2",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0, 0.564697265625, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 12.00000048877,
        op: 1769.00007205285,
        st: -10.0000004073083,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 0,
        nm: "calendr",
        refId: "comp_2",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0.145790070295, 0.61960786581, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 10.0000004073083,
        op: 1767.00007197139,
        st: -12.00000048877,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 0,
        nm: "calendr",
        refId: "comp_2",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [540, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Remplir",
            np: 9,
            mn: "ADBE Fill",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Remplir le masque",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: { a: 0, k: 0, ix: 1 }
              },
              {
                ty: 7,
                nm: "Tous les masques",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: { a: 0, k: 0, ix: 2 }
              },
              {
                ty: 2,
                nm: "Couleur",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: { a: 0, k: [0, 0.265743851662, 0.705882370472, 1], ix: 3 }
              },
              {
                ty: 7,
                nm: "Inversion",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: { a: 0, k: 0, ix: 4 }
              },
              {
                ty: 0,
                nm: "Contour progressif horizontal",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: { a: 0, k: 0, ix: 5 }
              },
              {
                ty: 0,
                nm: "Contour progressif vertical",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: { a: 0, k: 0, ix: 6 }
              },
              {
                ty: 0,
                nm: "Opacité ",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: { a: 0, k: 1, ix: 7 }
              }
            ]
          }
        ],
        w: 1080,
        h: 1920,
        ip: 8.00000032584668,
        op: 1765.00007188992,
        st: -14.0000005702317,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 0,
        nm: "lapres",
        refId: "comp_3",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [420, 960, 0], ix: 2 },
          a: { a: 0, k: [540, 960, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        w: 1080,
        h: 1920,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      }
    ],
    markers: [],
    chars: [
      {
        ch: "s",
        size: 260,
        style: "Light",
        w: 38.6,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [5.338, 0],
                        [1.108, 10.172],
                        [0, 0],
                        [0, 0],
                        [-6.042, 0],
                        [0, 7.855],
                        [0, 12.387],
                        [-4.935, 0],
                        [-0.806, -7.05],
                        [0, 0],
                        [0, 0],
                        [5.438, 0],
                        [0, -7.855],
                        [0, -12.085]
                      ],
                      o: [
                        [-6.345, 0],
                        [0, 0],
                        [0, 0],
                        [4.431, 2.921],
                        [10.373, 0],
                        [0, -16.113],
                        [0, -4.834],
                        [6.445, 0],
                        [0, 0],
                        [0, 0],
                        [-4.129, -2.618],
                        [-9.769, 0],
                        [0, 17.12],
                        [0, 5.237]
                      ],
                      v: [
                        [19.839, -0.302],
                        [7.654, -14.502],
                        [6.747, -14.703],
                        [3.122, -3.223],
                        [19.739, 1.309],
                        [35.852, -12.488],
                        [9.467, -37.866],
                        [18.832, -45.117],
                        [30.716, -32.932],
                        [31.522, -32.831],
                        [34.845, -42.801],
                        [19.94, -46.829],
                        [4.532, -32.932],
                        [29.407, -8.057]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "s",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "s",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "è",
        size: 260,
        style: "Light",
        w: 44.1,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.208, 0],
                        [0, -1.913],
                        [-2.115, -1.108],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [-1.208, -1.41],
                        [-1.813, 0],
                        [0, 1.41],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [29.004, -52.67],
                        [17.422, -65.863],
                        [13.696, -67.877],
                        [10.373, -64.352],
                        [13.293, -60.324],
                        [28.098, -52.67]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "è",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-3.223, 8.762],
                        [0, 0],
                        [6.244, 0],
                        [0, 12.79],
                        [0, 0],
                        [0, 0],
                        [8.862, 0],
                        [0, -14.301],
                        [-11.078, 0]
                      ],
                      o: [
                        [0, 0],
                        [-2.518, 3.928],
                        [-8.963, 0],
                        [0, 0],
                        [0, 0],
                        [-0.302, -11.38],
                        [-10.373, 0],
                        [0, 14.502],
                        [8.762, 0]
                      ],
                      v: [
                        [40.988, -13.092],
                        [40.082, -13.495],
                        [27.493, -6.949],
                        [10.172, -27.493],
                        [10.172, -28.903],
                        [41.089, -28.903],
                        [23.767, -46.829],
                        [3.122, -22.055],
                        [23.868, 1.208]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "è",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 2,
                  ty: "sh",
                  ix: 3,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-5.539, 0],
                        [-0.302, -10.776],
                        [0, 0]
                      ],
                      o: [
                        [5.136, 0],
                        [0, 0],
                        [1.007, -9.164]
                      ],
                      v: [
                        [22.357, -45.016],
                        [31.32, -30.716],
                        [10.373, -30.716]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "è",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "è",
              np: 6,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "r",
        size: 260,
        style: "Light",
        w: 40.6,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 7.15],
                        [0, 0],
                        [-2.216, 0],
                        [-3.525, 0],
                        [0, 3.021],
                        [3.323, 0],
                        [4.431, -6.949],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -6.647],
                        [0, 0],
                        [4.028, -0.302],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [-4.431, -0.302],
                        [0, 0],
                        [2.216, -3.827],
                        [2.316, 0],
                        [2.921, 0],
                        [0, -3.122],
                        [-4.532, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [5.237, -0.302],
                        [0, 0],
                        [0, 7.15],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [27.09, 0],
                        [27.09, -0.806],
                        [20.142, -10.574],
                        [20.142, -32.831],
                        [26.889, -39.578],
                        [34.543, -35.751],
                        [39.578, -41.29],
                        [34.14, -46.93],
                        [19.94, -35.147],
                        [19.94, -46.326],
                        [19.135, -46.628],
                        [2.618, -41.592],
                        [2.618, -40.686],
                        [11.078, -32.327],
                        [11.078, -9.97],
                        [3.625, -0.906],
                        [3.625, 0]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "r",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "r",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "p",
        size: 260,
        style: "Light",
        w: 53.3,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [6.445, 0],
                        [2.014, 8.762],
                        [0, 0],
                        [-4.23, 0],
                        [0, -13.898]
                      ],
                      o: [
                        [-3.928, 0],
                        [0, 0],
                        [2.216, -4.23],
                        [6.848, 0],
                        [0, 12.488]
                      ],
                      v: [
                        [29.407, -0.201],
                        [18.631, -11.179],
                        [18.631, -32.932],
                        [29.004, -39.578],
                        [41.29, -19.235]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "p",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 7.15],
                        [0, 0],
                        [-3.928, 0],
                        [0, 15.308],
                        [8.258, 0],
                        [2.216, -5.539],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -6.848],
                        [0, 0],
                        [4.028, -0.302],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [-4.129, -0.302],
                        [0, 0],
                        [2.618, 3.021],
                        [10.776, 0],
                        [0, -13.495],
                        [-7.452, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [4.935, -0.201],
                        [0, 0],
                        [0, 7.15],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [26.788, 22.559],
                        [18.631, 13.596],
                        [18.631, -3.021],
                        [29.205, 1.309],
                        [50.555, -24.875],
                        [34.241, -46.829],
                        [18.43, -35.147],
                        [18.43, -46.326],
                        [17.624, -46.628],
                        [1.108, -41.592],
                        [1.108, -40.686],
                        [9.567, -32.327],
                        [9.567, 13.596],
                        [1.611, 22.559],
                        [1.611, 23.465],
                        [26.788, 23.465]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "p",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "p",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "a",
        size: 260,
        style: "Light",
        w: 46.4,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [2.618, 0],
                        [0, 5.539],
                        [-10.876, 4.733],
                        [0, 0]
                      ],
                      o: [
                        [-3.323, 0],
                        [0, -6.848],
                        [0, 0],
                        [-2.921, 3.122]
                      ],
                      v: [
                        [19.537, -3.223],
                        [13.696, -10.876],
                        [27.896, -26.688],
                        [27.896, -7.654]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "a",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-3.726, 0],
                        [-3.625, 6.244],
                        [0, 0],
                        [1.913, 0],
                        [0, 5.438],
                        [0, 0],
                        [10.876, 0],
                        [0, -5.539],
                        [-2.82, 0],
                        [-0.302, 3.525],
                        [-2.921, 0],
                        [0, -7.553],
                        [0, 0],
                        [0, -5.942],
                        [-6.546, 0],
                        [-4.23, 5.035]
                      ],
                      o: [
                        [3.223, 0],
                        [0, 0],
                        [-1.913, 2.921],
                        [-2.518, 0],
                        [0, 0],
                        [0, -10.071],
                        [-9.869, 0],
                        [0, 2.719],
                        [3.223, 0],
                        [0.705, -6.647],
                        [4.431, 0],
                        [0, 0],
                        [-20.343, 7.05],
                        [0, 6.042],
                        [4.633, 0],
                        [0.906, 4.33]
                      ],
                      v: [
                        [36.053, 0.906],
                        [46.426, -7.15],
                        [45.621, -7.755],
                        [40.585, -3.726],
                        [36.96, -11.279],
                        [36.96, -31.824],
                        [21.451, -46.829],
                        [5.136, -36.356],
                        [9.668, -31.622],
                        [14.905, -37.564],
                        [21.149, -45.52],
                        [27.896, -34.644],
                        [27.896, -27.997],
                        [3.323, -8.963],
                        [14.603, 1.309],
                        [28.098, -5.841]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "a",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "a",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "’",
        size: 260,
        style: "Light",
        w: 22.1,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -1.913],
                        [5.338, -1.611],
                        [0, 0],
                        [0, 7.654],
                        [3.021, 0],
                        [0, -3.323],
                        [-3.827, -0.705]
                      ],
                      o: [
                        [0, 3.122],
                        [0, 0],
                        [7.352, -1.913],
                        [0, -7.251],
                        [-3.323, 0],
                        [0, 3.021],
                        [2.216, 0.403]
                      ],
                      v: [
                        [13.696, -56.094],
                        [6.042, -47.433],
                        [6.445, -46.225],
                        [17.02, -62.54],
                        [10.675, -72.006],
                        [4.733, -66.064],
                        [10.675, -59.72]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "’",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "’",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "l",
        size: 260,
        style: "Light",
        w: 29.9,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -6.949],
                        [0, 0],
                        [3.827, -0.302],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 7.15]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [5.035, -0.201],
                        [0, 0],
                        [0, 7.15],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-3.726, -0.302],
                        [0, 0]
                      ],
                      v: [
                        [19.638, -75.027],
                        [18.832, -75.33],
                        [2.014, -70.093],
                        [2.014, -69.186],
                        [10.574, -60.828],
                        [10.574, -9.869],
                        [2.921, -0.906],
                        [2.921, 0],
                        [27.09, 0],
                        [27.09, -0.906],
                        [19.638, -9.869]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "l",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "l",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Superior Title"
      },
      {
        ch: "-",
        size: 360,
        style: "Regular",
        w: 38.07,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [3.021, -30.515],
                        [3.021, -23.969],
                        [27.896, -23.969],
                        [27.896, -30.515]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "-",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "-",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Belleville"
      },
      {
        ch: "e",
        size: 120,
        style: "Regular",
        w: 20.5,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [19, -29.2],
                        [19, -37.9],
                        [10.3, -37.9],
                        [10.3, -61.3],
                        [19, -61.3],
                        [19, -70.1],
                        [1.5, -70.1],
                        [1.5, 0],
                        [19, 0],
                        [19, -8.8],
                        [10.3, -8.8],
                        [10.3, -29.2]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "e",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "e",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Belleville"
      },
      {
        ch: "L",
        size: 120,
        style: "Regular",
        w: 20.5,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [19, 0],
                        [19, -8.8],
                        [10.3, -8.8],
                        [10.3, -70],
                        [1.5, -70],
                        [1.5, 0]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "L",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "L",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Belleville"
      },
      {
        ch: "E",
        size: 120,
        style: "Regular",
        w: 20.5,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [19, -29.2],
                        [19, -37.9],
                        [10.3, -37.9],
                        [10.3, -61.3],
                        [19, -61.3],
                        [19, -70.1],
                        [1.5, -70.1],
                        [1.5, 0],
                        [19, 0],
                        [19, -8.8],
                        [10.3, -8.8],
                        [10.3, -29.2]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "E",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "E",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Belleville"
      },
      {
        ch: "D",
        size: 120,
        style: "Regular",
        w: 26.3,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0.4, 1.434],
                        [0.9, 1.067],
                        [1.466, 0.6],
                        [2.2, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.467, 0.6],
                        [-0.9, 1.067],
                        [-0.4, 1.434],
                        [0, 1.6],
                        [0, 0]
                      ],
                      o: [
                        [-0.4, -1.433],
                        [-0.9, -1.066],
                        [-1.467, -0.6],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.2, 0],
                        [1.466, -0.6],
                        [0.9, -1.066],
                        [0.4, -1.433],
                        [0, 0],
                        [0, -1.6]
                      ],
                      v: [
                        [24.2, -62.85],
                        [22.25, -66.6],
                        [18.7, -69.1],
                        [13.2, -70],
                        [1.5, -70],
                        [1.5, 0],
                        [13.2, 0],
                        [18.7, -0.9],
                        [22.25, -3.4],
                        [24.2, -7.15],
                        [24.8, -11.7],
                        [24.8, -58.3]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "D",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.4, -0.6],
                        [0, -0.8],
                        [0, 0],
                        [0.4, -0.566],
                        [1.133, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [1.133, 0],
                        [0.4, 0.6],
                        [0, 0],
                        [0, 0.8],
                        [-0.4, 0.567],
                        [0, 0]
                      ],
                      v: [
                        [10.3, -8.8],
                        [10.3, -61.3],
                        [13.2, -61.3],
                        [15.5, -60.4],
                        [16.1, -58.3],
                        [16.1, -11.7],
                        [15.5, -9.65],
                        [13.2, -8.8]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "D",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "D",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "Belleville"
      }
    ]
  };
  static homePagePetals = {
    v: "5.5.10",
    fr: 29.9700012207031,
    ip: 0,
    op: 1779.00007246016,
    w: 1080,
    h: 1920,
    nm: "PARTICULES",
    ddd: 0,
    assets: [
      {
        id: "image_0",
        w: 101,
        h: 69,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      },
      {
        id: "image_1",
        w: 116,
        h: 103,
        u: "",
        p:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAABnCAYAAADR2GYSAAAgAElEQVR4Xu19aZBc13Xeudt73bNiIQhiOACHAAiQgAgukCVZtmNkKSdyxXKWQtlxTFvlJFS5UnKl8ic/gypXpVLlqji2HFGkKJHUaom2Y0nW4k1bYtqyRFlSCJGiuIAkAA4wa+/db7k39Z1zbw9IkwQggpQoYiiIxEx3T/f77tm+853zFF3+ek1cgSN0xH5pgSzRAtGJhYLomH+hN65eE5/mdfUmgyJSRIdvb04s92f9qMo91ROhGk0QOTJlsTKcbizSyfsHlwF9DR2MxlW/uEBGX+uH1aw15VWeim0+eF9Vatlr8z1S6hFazs8Q3V+f+7EuW+gPC8gL72jQUE03stF0XflZQ+qwIb+P6vJqouE2H0ZNX/sieFWFYB4qTfY58hNfo7X7W5cB/WEBkUjNzx9tnCRqZkrPWXK7baBdNdEuTdU+FYq54EcLwRcztR/Wvq49+dAIyjxS+eanvdIfp/XPf5tIhfSRLlvoDxZc1Zz7xflaq806mJszrd6kVLhBq7An+GJTCP0JqktX+5I8/6mJgifv1ar37uuVz95HM+ufpdMP9i8D+gMFMija/k8nJt3WPcqrA+TMHkX6Fqvr/UT1dvL1bKgLE8JIh1CpUHsKKlAgRQom6BV5r89W3txdWP1++vUfO0HHJOu9bKGvJrBHjll67PgMabdpsgp7tFE3kbF7nTE3KaLrFJWTPpSNUBcUfEnBVyS+VJPWhkg70vhDjoKvR8Oq/iQFet/UFflfn/n2h3qXAX01waSjZtsCbVsr7bXa+91Znr0pt/aQUrRDK7WHgre1H1HtC6K6pFDXbI1BGVI6I2cbpF2DtG2SppwCVVSWvW+XZXWvVvQHq4/f88xlQF9hQI/RMX3HoQea7e7sVlvn8+T9vjrQNcbqa3OX3+CMuTqEeiaEesr7WlX1iGMlcawkUtqIRdoJcm6CbN4gpXMiZUlRIF8NTo+Gg0+NquLu1uN3f4OA/yv8mV6vLw/bItr/81NTrcldyvm9Rps3kjI3Epktztkd1ujtivRkoEL7umbLrOuKfACYcLSKtLJkbU4umyaTNcnASo0jrw1Z/Ia6KAb97p91h4Pf25mvfPH4Q58oLwN66Y+c2rL3306PWsWE1/WCsc2bnQ2HtDZvIWN3ae2stWZCh+B8qMjDvYaawQzkOWZy8qMNGQa0Qc5NkXY5GWNJKUNkFP5HeHi32/qL4ah/5+q6/tOw9J7eZUAvDaByHRfekTcLf6VV5dWBaKcntT8z5jrl1BussXuMsk2lrdZaGV9XVHHyA6LHUwhIUuFnFSc/DKi2ZGxGzjTZMoPWZJQhDUCBqNfU7XW/0O917lhdH/4pLX+gcxnQSwOovMrC0avywt6Ya3VAG3VIKXO9MfYK6/SC0jbTZEgZlByeqrLguhLWyTapNNccSinSFrESGa1hq3Q6I9KGAn6mNAOqlUIlo7rD3md63e57rAtfWTr+nu5lQF8uoEePmskv2ytKpa/Uzt/klLnFZeaAIbNXW7PVaA1fOYHSA3wO3Kr3FVVVRcGLgyUNQJHoKNLGSDarMrZWawxZbQXQWIdqrQFsqH1V9vudPxp0u7+3Vg8fpBP3Di8D+v0CevBoRiOazfu0hUK4xrrsFqvNW4w1C86Yea3MJm2MNQaWpTnPQSmSGJ+aM1lprJABeWc4CTIu53gJQGGRVsMa8QDNiZKCWbKlKhqVo3a33/rYsN1/d/fp732X6EvVZUC/T0AnrvjlHYUd7cu0vk4Zs99p9+MuM4eMNhPaGGNABBi2JALH430gX5ZUVyUFheRHMlkApfhxjqzOSbmM4yVAhEUCOLhjHAqBVP5Pa0XDov9Up7t2H436d68+fs/Jy2XLRYEJc/qNbGZ+cdKrxlxd+4PK1DcZbW8w2sw76642Vm9TgFFbhdhHWuwFsZL/lJGPlaJGEiCAZjPOZo3NSUUwjcZBYJukACiBPXImzoDxSxQNh71vrbXXPlDV/Y91H7tn6TKxcIGALiy8o7FS+kly5bZi5HdpZfblTt+ktDlorblOK7MZrlUZgn9l69IMKMD0VFcVVcwA1WMQYX0ksZDBtK5J2jqxWICs8W8pYeB6FftsnBEkRQC4Hg37nS+02+37Vr35HD327vZlQC8E0PmjzUbpdlgbFkjrfRTC9U6b621u9xhttyujplEbwjWKG0WZaDm5AQJVXVMFV8u8bGBXOXa1KEuQxcI6DawTzxGrVihR2IcqqgFx4CPAma81mnwoV3vd9mda7e6HG53OX505c5nLfSk41fbtt02c8cNpqrMtzUZ9Y2bNzdroPSqondaZeWvcVmVtprjSh+Eh8UEtiaJfk7aak6CqKqmqPdVsYchiBXSUJagxrcvJmoxjKJId7qngoWy9YnMAFG0zHBp4Amc0jYaDJzut1n3tUf8Pu4/77xLdVV620BeF9Jhuzh2fD95e64m2W6t+aiJ3P26sAZE+q7WdNEYzawMLEqqOvS27S2ZxVGAWCOVJ7Yl8gJvUpLSAbk3OYJos47JEcaqLp0VAOVmKMZi9LSKpIueQMBH1+51HVpZXfmtU9T7bO3HPmdTkvpzlPgfU2x3NPTs7qRrzRPqQttkhFWjeOXUwc+4aa0wD2U5gFMUqpSWCv6ArInFPBc8MUF0XVHqwQPiuJaXFAlGeONcgl+VkkNVyjMQBEbfKj+LMVqKofFcOCwCt66pur69+5ezS2m/uObX2V8fp/iJ9jNc9oEfpE+Z+up9obzaZdYt5Y8wBS36ftu4NxuQ3OqNApE9rqzKUIspYzm1CJNDhJhlUuFmuFYPUmzXiZkmi4ML3EVfFSo1BVouWmCNjXGJvOXMF6Io5XWS5ijz/npjdwuVaS6Ni1F5dW/nk2trK/yj/w8K3U3P7ssslor1735Y/VmyecLXe5XQ4nBn100ar65XRO51p7LDcwsIV9Zx54kJ7T1QHzkUjlqgV5U9AVltXVIN0Jx8JAbwAag0kNAAz56TJGiukAQWQgkzpAVDObQOyW02Vh4WKu8Xvxy/s9HrfXVs/e2+11r+3t3Tv4rlO5vVqoYoOHnWTS6PNnvLdRrt5ymm/1W5/ZvStytCcIdNQLmsYBg1OUBrOnKR4qQ25JkT1wfFU4h9ntbBQyU35uYiv/G/rOKMFqAAOtaa0ySKBwHiljFasHskUoi4DagwVZVm0Oq2/7ayv/K9uoT5Fp+8a64lepxZ6xNIVM808b+7IdH0DKXdAB32jdW63NnbGabWgnWoyCHCxsCy+qD6CgwRHUQiShTIYcJOcBAmYVfD83I0LDCvXMasFTwtXG2k/ri2fD2gsXhBzhYFgy8Rr9gaD1bXO8qfarbXfK5++78Hn53WvKwudnz/aXDX1Jiqyq72hm5xWP2aNu8Fqs88Ys9lo67XR0HiMa0X8F8cxXFD+J7I88W+GwcBjkAR5qtDXxPccZCKc3pJiAA05ZLVwt6hbcU4kGY6EkVg715qpGuWDwoUQJ1xIrtq9zomV1tIH1lvt++j0B59+HQJ6TB88eNyeWLKbzURYKCua06T3GaNvdlrv1tbtNMZs1UpbA1Pjyp9NT8CLJQPiGbJaDZBiQoTMFsoBZLWwTGS0YIY4QXLZONlh4sG4CCg428QCjU9HMsKY5QrhhxxLGCOwQ5bqqqZWt/31s62zv9W0+rNol73uAD148Gh2Ymm0WenJ67WhW7TR12pr3mC02aeVnjHOzkC3k9wjVxgAJPKwCvghhsZsVihzbmRx0sIlBrvaiqqQSgyxKHazaIdpS1pnnKHie2B6hFni3jbHSK5kuZMidJ9GPRoBRRxH/BwhfrbbX17prP5m59HlB54/BvGjH0OvePt01sgXDKl9mbJobYFMv0pbvUMrPQuWR2urcfFxJbk9GZvNHBflr5KpxoQIoQ9gcLUI0XNAVgtNEBIhgIzYKYCB1rNGShOAym4buZERoLkbii4Mk+4g3BOg3CKVmI3XYStV1C+Gq2vtzqdWWu3/Pnryju++EC/yIxdD99K78sXtJ2eV0VsGyl2dGb3HkT7srH4zGbPTWQeWh7vHDAsIAaXJPwdQlu1w6SAgpMskHhlxE263hvIABAJcLawztrnYNcMdM0+bc73JvyO6awHUsmWyi46JkZUyVagEL4dGsmiDx/l2r/v4erd731KvfTc9efeZ1wWgk1e+fbs22b5g9cFaqf3WZrsa2t5krNnDhLeBVscIMRCtD4D5WMiLheJvLwSo5uJfw3zgZn2gEtbJlq2Zf4VrBpcLPRAr9qxj1QGAAfhwtIihsFgGNAiFACsE7zAm+WtxyXhvxlkq6mq0ur7+9U67/e7VVutPKJLxP6Ix9Ha3ZUuv2ZsI27Wiw5kKtxhlDnptrjZOb8qU26KdmQFYLN/QNgK6YQUcJ2PmCkBTu4rpvETXAii21lripg9UAVuGP7rl+BgXe5yZswwUfjcsGeUNAEdCFT08aXyPD0p6fUhzxRWjvAE71Qc7tLr8udVu792Dx1f+5oXi52s/hu59Vz49aE2pvNpSjNQuo/1NmTUA84DVesEj6bGQgVhWBcBNCqMjFipZLACWZrNUJ5LooLvByUksHaK58PMg7MIF56Kf3bWN5Bx3txkw54QRclZeH9wurFFaYHDlRkR++DumHLg9KrojjuecTAvQ+B394fDs0srSRwa91l2dE/c+8kLu9rUN6N635U0/tT0v7LW1CnuU0oesdbdYZ3ZnymxH619m1sF/ioxDajrEMuFcNwAVYoABhaUw0HE4iBkdSY7wc1gZkiAmF3Dho7WJzofIxthpwNNq1J5CQDC/C/fKagOx0Ng+lWw2FqSR+IuZroBc1L5qdbsPn11durPdLz5GJ9+/+iMCKLKUd9qpq8pNwfTnrPHXGe0OBpQgRu2xkIIYu1kr11Baa2lbBXFbkY0RS4xWCELAb1ihGAcLPsbEgijxhNar4WKZpwVlgFaYpZqzXsRlcZlZVOmhbuQEyko7zWO006PTQmQtYiq8hBwcxOSYOPNvTmJAbgbAOouys9pae2BtZf2OfVu//tkHH3yQe58/GknR9M9d0ZyY2Ksa9kCm/CFn7U3aZrsVqa3W6AkmByCJVIYB4IsIl8YZY9TmpKE70HVMsks2KYCK/XI7LFJuAGusPqiQ1cI60Q4ziKbiYq1oaDOrWakH6lAE0ZLocEz04kIlSRLNELv+1DbjejcwwY8fotzxQYf2YPDs8trSJ9aWu3cVz9798IuB+dpxudtvm5xo9GZMFaZHpTtgrTmUOXeTc+o6Z+0Ore2sJ+XgybhGjKUIqDKOWxAms4wjGl4izRlQuTxss/yADamHtMOEmgMYyGihPmDdJZrSSlGFZrVSlFtL1mWUJYvEQWH3KnEZhwuCBoDN+qN4SJLblRgq/VJWPgRYt6OiCr7V7ZxYXF76HTrT++D6+r3rr1FAjxra27WUT4W8Rbsc2ZuUpX06qN2a3B7r9A3O2k1WyFHFlhZbk1K/pcxTmDxJdNK0Qawt2Soldm4AKiS8qAiAhowpoAdactss1a4gCuQlUYY0DDS1SIQkSrPkJOpq8Xo4B/gWkiQmCrjVJt1SDgecfSdFURrutTQYlsOV9dWvnV1f+2+9x+/8/EuB+cNtoXvflk+2pjb3nHET5A/nzv2scfawNWYbkdmktJ5GjJEEY5xfSEITAxKT2oiffBXg8qI1MtEuX8hluT3FSRPgiYCy20Z96iURYjClH8qvKxUPW6HTlnKIt6xjN4vXAKCwQna/ATWovMccrjm+Z3RnJOsVDdKG7lZcifeaOv2iu7h65pOd3uB/9p+48+uvQUCPWdrzrS0TveyaitQ1SuurGpm+Nc/tG622u7QxDVAygbSTzPV5ljk+pqzuIWWkusTVlO5/ynbFYplHZWAkuxUqN7potqxUa+KBKE8ETK5aIcI1iuDrs0haIOsBmPybwNvCjXpJqPCVZ5Ytmo9OAhTcbqIaI9OI3zAqPHW6w5Onl5beu1YNX5QdOhfkHyLq74il+W0zuadtxqs9yrkbgg57cmOvzxzmROxmZ+yUqOukZnxurzAlPoIKMy4szNrIWuWapmaKAMp6H86CpW3FSvfYxsLFqTxUd1LqsMCP2XtJnLgEsZqcVuREYc0UojBHsSblnia8A78CZc6QsRs8Lj+OY3z6PAjPMjrRHxa+1e4/tLy6+tsr31v6KJ2jHXoxS/2hAXTimn+1Iwzs7srQgdzam6w1+6w2u3Kb7ULDObDVxLiIixrbWkKIIwax7Yh1RUD4Z1FFx9ScSM+lDRaV6ABIcZ0aZR8SbceWXwdDPqBugQvGhYabrJHDMphQ/6FLgjqSs1mOjfGAcA0baaYow0TJkoh5/t2pq8OxXE6CtZaTr1an32l3e3+x1Gn/dufRO/7P+dztDzqGaqKjdnZXf7IuGnNk3A0V0T5rzUFn7fXoUeZab8mcmwCZ44NSop6T/mDMB7mwj+QKC5NxAfGHSYDUnEaLcjyuJ/SfSEbklTj3iSkwDgH/Di4+8TqwJlgm/o2LXpHWnl0pa4KS0g90YWx9RUKRD5m40mTVohuS5whjxUrA6G5QMnHGrR2Nqtqvd7qnW53Ox9fX++/rvEh35fkg/wAt9G057XRbZ0I+H0gfUkbdanS2x1p9ndEWTWiXO4u5H6714Ma4d8zWFde7cPyTCy20ntR5nHQAUJABHKySKk+K+AQCzJWTlphUsSvHa7PwWTqf4mKh7UGSgiNSk7WBMv49iKmJdeJUeSNrZdowxmN4EI650SJja4wlLlLiil/AocJreEP9QTlaabe+sd7t3rnk2p+kb750uZKAfbUBlbe/++hs1vXXGGf3G6Pf4Iy6VSu717psizFqEwWTATTuSrDsX8oFqQREfyOhkE0gquTQvpJRA1EWyMnn543lIkKxjbthcJsxfoqKT2o/kzU4oQJ+PDUGGFlfK+7WGqKMn4eDs0EjiqWfa5Xy3/wnxnXOnPlgiiqCXXVqk8FataKiCNTuDLvL651Pd9vt96w9UX01KePP53ZfNUBZz4OhHj+aKmt1tdXuBm2zG7NM3WKU3qu0mTQOowVaI5lheRZbj7hPgDoWHMd3zYM7DKBINlITGs9h0DdKT8lIU9yM7hUuzzooCkQMBgbHZRnpLCdfY1yvprKE8h39TqRGANST00IQMOHAAmnJaCOxJIR6BA0fgdtiTCiICbOhR2tNryMZs7Tfuv2SVtd6i2dW2u/t+f7dg0ffe+p8QL76Fnrlv9k+ZUb7lc52e6J9zrobrXX7nDN7lVKsGhAXBABjYsPA2TgEJCWHlB5iZQAU7Sy2WuZbE3cgo+vSmBZdazRqfkwi7VE3MrvjHGXWckkBQMHRjopAvcGI+kXBWh7OdREnZbgv6miFaeLyxCJ5ksTIGil3uDHACoVotXFQKWXn0gMd+1zOfvG0dmcwOrvc+dbyWud316rOH2Iy+4cE0GOa5k43qOzPNRvlGzOjDxll9illrtVWbzdMpOsJUZ3HllJ0PwJArNwj/QaQqlqoMVGNANDohuECo1tORIEU8LjoG6tiEhsA62w0GpRlOTWyBk1PZtRsCJlQlkS9QUXt3hB9SBZNM6XAnKvMnnBqZuUEcePcSo8VYGOYSEoXxPQNQDfYCPlsfOhifczT2s4w8b/e7i0vrbY+u7zcu7Pz1HseuFAwX7Es9+DBY9mp3omJ4XC4Selqzit7qGnNT1hn9hltdmnN7S3YZQRSFHWSxcZkgt9dTP/jFDMuwhjQGMOklSl8LQ8RREYGlsunn6uGqMTiYSGMJEAaYinPc8ryBjVcTptnGtRsaCqrgrq9itrdgi10VAHQijNo8ao4UJIoYQRU5olkChuxAcA7JHKxrIKshOlA5mmTpCVKNeGN0Ffl94z4raks62ql03nk7FL7Q6317kcHp+7GZPYFf70CMfQT5or9f7Q9FHq+LP1epcwBrfUt1mp0Rq5QGPiJ3Xp2ojGWIAkRdeSGPhVXcKxRj64VLgmJCi6gKM+ZJIuHHzWgfPYUuyRpQj8SFxV8K+SUGU3kOeW5jL+j/Ng0nVGeEw0GQ1ptDajVHVJdYlAXU9dJJhI1uDH7kRpUPIRkxPI4uOC0P1zKG2TOUREhc778PNm7EPusMeEbFWV3sdV6YGmpd+d6oM/QY+8eXTCakem6mMe/8GOPHdN07LSBDGQ04Rdyp/Yrov3k1X5tzIK29mql9TbZ0yO5emogszoOp3ejfyX0G34Tek+xRpNSBY8T6aPE3HQhU8srke9y0fhPVNxhKQXcK0DMMseAoiQCx4rWVrOBZrSnXn9Ay60e9fpDLHiPO4Tk2CAjZglKXGCRMliO1eP3Gbnk+Hkkw43sFGIpaL5YL4MSxAHkrk0dqPI+9AfDE6dW1v94qdP+QPH4+x+6WHAugYUeNdu3NxpnTNV0xl/bUOpma83NJugDWqvdxtqt2roGBR7d2gCFaxAWPEYJSIoA8pbEk4kgWWpM+Wgyni7lAZcAIpMbS7z4MIwvIFxrxiN4mPaaaMCtwko15S5n5qE3HNFwVBLYYWs8pB4cOzFGD0pPKEQ5SDhEKKVYLZ/mUMa0VIytSc7CjFEM/rFadXlsnUUPg74nHgOLRhLVH1Vlt9v91jOL6/eM2r37u4uyN+Fivl4eoMeO6Yl7HtteFqM5rdScMfomp/XNeeauV8rNaaIZbY3BDh5Z5srwcb3IygDW70R9B7r2yTbH5UUi0lObSzJHqenkYsWRIPl7LYoAFmCx/COnZpZRI884AZpo5pSBdOXEUlNZVNTt9ak7GFEdajLK06goqCirqKsVi+SDI/GBZSUZk+npkEniJYdKmCo8jkn/GBvx+3KjKcvjVhQ0u7nkkdYdQgcstN0dri2vrH1u8Wznzu4zOx4gOlZdDJhjQ7jYJ9Hh2x09sTaRT5VXmNJdb3J3AwXar7XZnVmz0zl3tSKTo8Abi7Li4CrbXIwjUisKdcfLl1KjKwKalAQSnmJNEi2apZRMAsXtWrDUOsohbcabRRjEDGWJpbwhpQm3tmpPo7Ki4XDILhZWilEGZLFsNeztwbmKtJJ5nhicETFyB80tDo6UUmmMPoUPPmjRDXPmazQ1naEMTwJJUnnCQqE0+wnutiwDrba6z5w+vfyh5Xb3ntHJ9z9+zqDEBUP0/Vno7C9tnppVO+qiOGCdeXPWyG/RZPYbpTeRNhPOWhBsseshroovPlwNE+iRQYkWKfypAMTFelQXiBQkmWvUycYsWIa7YpsKC5tYmikDsU0kPGyRDWrw+IHEaVzAsippNCppMBrRiP8UDK5MVkflHSdqQloAA6YtItCgBAGMc+J2Y3US224xRMSDBhPF20eNiudwYxsx23sq0YFhPZHMrfRH5WDpzPrXTy6u3pH1Op9KSzAuGMn4wIsBVM/PH807RTlXZtl+p5oHtKkPW6uvdzabU6Q2BQhIkdAZF5tWwq3yVDLHlKSs2xihw/tg4iR2GnAFngNoLLzHlF+i/zhWJVUArDDjHT9IeABos9mkiUbGcRDWVxQFDYcljaqSBsMhDUcjXgLFLFAUb8loIJKtOJgU9wFxIhY9BMIEyhKo+eTMCt3IWStKLwZMOicgDWHlICxYdoJ/WGgGcbY0wGHxoB1b3f7qs4urn1lcbb938NT6V19Md3s+gC8M0O23TV7VNNuGqr+rLvV+ZfQNirJbskwfzDK9xShOzBmIcd8w0nFikSk7FEBTuSIzIrJUNOlRk6pHsNqYaE7UGeo25moj1SbjBig5UFPmlGcYqrWUZRnlmSEdPAPY6fSpNxjSqKo4TmKZBZ8JXoS40cNJlBzzutGTQNmXZNhom4EihJoPc6AA0sEFc8ZNVFXgfXnOm689uis4ZHgOF1hVRUWJdkOg3MkOv/6wrhdX1x9aPLP2wcFa76PPn8o+H4jn/vz8gC4caUzTjgXt9Rs0hTeS0QeMdbtUMNehtWXhemILSzoiktYnBQAzKePSJO0mSJIPiSPS/Y/lQLLUWKPyWB/zsIqsxTg8XJW4KbjZ3Llx0tNsNpilSbwvqDrsOugPBqDT2Cp5iQUT7Z4THLwmlyPiwaUVF0VkMoEmCQy/B2S5cXgI7wuiMXggxFSo/WB1o1IOLQiF1Ap1GdSAIsYuy5KKquLP08wdN9BXW4PW6eXVL50927q783Tjz4kurva8EEAVHb7d0mOnplzWWHA2/7EsU4eUNjcaa3cao2esyWasNk7iIeskRdkWiWfuJEQBFjdyY6+QT220WHZK0M2OS424p4ePWSLcYyzTIpVktwYrcTllNueL0mg4ajaguMMMpadBUdKoKPnigbYbDgfo/sswbjwoKV6mhjNiRWKCWTTGoSL1XeWSMfjj9y6uHAcx4zIIrhOARk0SjwyKdNM5ARSPRQaN5yEU5Lmj/tDTqaX28WfPLv/Berf/weHTH3jiYizy+Y99cQvd9C82kVLzLrNvbWb5kTzPr7fOXaON3mytUbAOvuQxsKc4g9MvraGNdJ47+CnBSUlNJBfQY0y6oHFJE1tgUcoue2PZQqOyzkSSAEQBrCPTnMkiRvd7I+oMhjQYjqjknbSyyrQAwc79UiHt04iDzHA6HtxNrTW8jnAHsiEM74NBtsL6SG2KeSX5rAAU0hIAWqaQEMXZeCDeG8IArgHeBw4xlz7G0Fp71HlmceULi2fXP9zqms/T0t8f4r0YgF8A0LflNGvn8umJ6zOb32S1eWue5zc2bL7VaDOprNZpPwCkk8zajOm7mKlG8LB1Mkkn5Vsiw0qkgPSlEU/OSZJiT5HLAXaBsArZUQDKDqUIrBJJEE6+rBtFuRE4Y+10+wworBNbo+XGNeIJxL3GXUIxe0bWyuQ6DxFJC0v8BFPrfADE00gSw8KHqOSL3Ag1MO4AVx9zJ1miAXE1SiHJcgEoDnvBcn7RFiFEnVnuPvHU4vLHllrdjxRPvbSI+kKATYAqOnpUb35w81RR9HYZqm9s5o23ZJOTb7lo5+QAABhbSURBVG5k+V5l7DS4FissM7MquEAcq9KEeiTJuRcZ60mRVESWRaY1ZKYjbeHhRRPxYrFSIJYzcb6Ss10QBBwvYQWO3VQD27did6PAPqCiZLanNwBJ0Of/xiCubPqJK9nSnElsYaWR9yRNEVIAnREo3sX7QkYp8V9KmvFxjTogJhMUcfxkEGM4kQQICZLsW+AkCoQ9L6PypANChqXusCxOPbv61WeX1u9YXhv+CVaMXwhoL/UYAfTYMb35g6enfTXa25ywPz6ZN97UbDTfNDnR3I9YheIdBAC2XeFU1RCFxGGecZrOwVFYWClBJIYybzvOEvEYuUUFX2wcjCpOfTHvmvjSSLzz5kkjqnRW18UEBvvXOV6VTNWhnhwORzQYDmjIblZoRVkeLDpNPhQoNWLyw++B9wonxYFs80KSh3PLgNax22MxhCSvIwNKkdYDbWcgnhaxNVwxhNQoa3AFSnavwt8y2cALjiQZQ4W33O6dfeqZ5T9f63R+p/3E+772csGUzANfB49mO4rGnsbE5D+emZ78mYlmc3czb2LaeQYWgoK9AqPjE4kspQa7RJ4fkVpSiuykXov9PsDHRY1ILZDUIHPinXYgTjz+vlEi4GKycgBxE3MizlITdRw/DfUbmJ5Aw6KgwbDg7siwgIsVokCa2SIPkQEiaasBUBwYsTLpWzJxLsYkYEVAHVSAUVmYBPjSD5VVN6xVqiJ3ixYa36hBtEw5AI0yzaKCuxcun7tEyDd4RNBQ4ak+tbT2dydPL//+oKw+3HuRieyLBVlM6tBtE/Nl/tM7tm+9bevmmX/SbOQzWmUZXI5kotCagm/0VFbQqsqGK7gQ2ZsOQCPfGUXGLIKOfUOWx0bChzWq8Q4IYh1IeKQNxcyMhQszzH2ivstyQ02HW0NVbIGoI5Hw9PuDyPZIJovV32meMu1MgI9gUNntSbYsJU0CVMJH8iipJ5n0QnIgRGzGk9fsji1n88im2cVGXQs3vY2mhpVSCB+4qiTLRZHNFQDKGX4fGjKT/lOLK58/tbJ217aq/PKJi1AlnMflBtWc/9W5a66a/tXdC1f9+62zs9cajXQ60HAoa1qEa9XMslQVXIfljR/sQuImLLAdSWAsho9ms3CdSZIus0BiJbioUOnAalE7isgZpz3wuACXAlaRQwZr0PhF47lHPbjXwUBouwryELEUpSCvRDcEgVhcvqz4Tgss4K43CPFEeMgeWrFqGfDVPHAE8HmiLNabeMdCKGwAyo2WNGDE7lfxYeSlxkiS2Huh5o3K+ZipV3Udzqx0vndqef2Da+32R4Yn7j1xsZb4Yo9XRMf01M6HD1y7c+4/H9y741dmp2ZMUaLYHVKnX3LWw92AEDDnz6N0aTUaXHFqVcn3x32v+B9JJxRVAywsFr0rjxjAHSGFh4uLtC3iHjJAZxC3kJni4TUDCCIdMbMspfnMi/gjaEhceIUMu8WYjMXDxswS4jOLCmJnJGalisuMSE3GTg74W3C1XCbxQZY7OHDrDARC7KGKJFSkmLKfKLbHCIcC3xdAOQzhxwYyE0etXq96+tTqF1dXe3f44L+w9sRdz7mp68sBVyEhuvL3n3rLru2b/8v1u+fe3swmqd2v6Oxqj7qDYVzooGhY1syMcCxgG7NRwpg2d4ChEaWWbA9Bhoglv5Iyyr0vAaisdxFVexo/wEfwctH5dMueHrhZrfE7SyqRybJgq2SxFlwe3oa0q5BFCvvEHVYt9WGSb47XtwHopO0F64TfkerG2HAF4IjjDChnrjxBzdaGAyb3XYnvPZY5yRtt1LdpXjS2D/A7eNcQR+9wZrX1zFPPLn+42y0/1DlxF9bTSNy6BF9sGNfe+o6fvGJ2y3+85qpt/9ro3C61RrS83qXesM9cKDZllbwVMrpL5mllzgMUGl8LBkoUBmJtABcxZ1zEjIGG9pRv1MbZM7PZMgMWM8UktxR3j9iImlLWrjF3ajXHJ0lsRJqQprRFuysEQqSn4i49vF18lrilxMXFiNxDFVfL+ULlyWWQc0oY4IQw1tom3cqKRdfY5yefU5oJcS4Nn81ABZg6PKAa4++0bBjls0utv15cWb9LF+bPFh/73eVz79D7cjHlLPfWn/z1w1PNidtmZ2Z+ZViazUvrQ2p1e0yZ+Ro3WUNHX+70wy6L2Za4H50Bla6B0CvJQqPEf7zg0HL9xVwEJxuWeVHCLnYsqIhc7ngknoeEYNmYPkdWLCUEwITlJJIf0hIQ5byalIt5OWCJEUqpPLe6+KKntpgM+ML1swIvjSXWgRoNK4U/3wEJ7w1slCHF+xXEQ1UVbgggXkGGAiV0wy1z6RPfD7wat/V44juEtXb/mdPLrfvbg959a4/MPfz9NLHPkxQRveXIf1qYarh/6XX2zvV+vX+1NeJYVZUiYcTVg4QjnWJpL6EdJGMIY3I9ZbiRDeJFS5zsyN4e1HkBtSeTD8hu+Q574nFibJXyQF5fehLYtZ7UALJAP4mqOblCqQEXHVec4m64Sdpy7iBQPGtjQJntilyyNNxl3gTlx0QTQjJoc0sqipoPa96wXHtwhov4z1pdcfno20ivF3EWCZ0AikNX8M135PNXdTlYXG399eLy+j3DkfmL3pPvOROd3ss1zPHz+Wi9+c3vmmlO57e2h+FdrUH9z3v9IiuxwJd5WZw63FxNuvYMINMm7GelOxFVHfyq7G/THQ0kw5NKMLpe0HSRCZJFd1WkDoXGk2xXGCWO1UzJpWmu2CSOHZk0fc2LKdBvjEso2EvEPbcskIjjD3Lr8bgNLLI9TPJFQLmbgmnsHNyroSEIfpQnzFJFPRT3M4PwuFxTEtVx5J7JQiVZMtgjxFqEKiSMuF6dXv/E6eWVjy+u9j9cPGPGi/8vGZopJz18+E5HEw9f0er4dw7K6tdGZX1VIO/YUljdLe6VZRhpvxJrZiT5YeGWELMCKPOfnCrE95qmrYR3laFZAIabn3IE4voObKhEaUl0kqRTlHbCBbP6T0xTOFx+aHT5/OvGQzBjdQR3hNKPxoCmfg4OqADJKgWm8sQTgEgHkbGR7AhDJA3s8Uc9l67mj4/nohRLPeKiIhoOq8Faq/PA2fW1u8+sjf6Snv3AcrwYlxLP6PzjS27b986frWv/G9qot1prp2XU7bmdEtmJHhfl82Jg4YBSX5Mv/ng4Rz6UfHSgIJu0IBoDEp5Ansf12wyorGXjWpxdaDwYsR8pj4z0VlzKxECfM2IgPxfKMWmS0syo5JxCsAstKLUz141RFsq1ZWx4SyINlb7Mj6ICGdOBEfwoOkyTVHwlZfmUWCkO5qj0fnW9/+zy6ton1oaDe9YeefRh3KfskiIZX+w53Zbpa395vwr5L+VZ9vY8dwexeplV4rx1Moq40pwlsz0SJRHHwKbACjjRiU3pVNSLsi/eI5OveFwZE1+DiwO+2amULxyPuKshowLxJWN9tNHRkcRnvGliPPcCt5emsPm1GSw+heMQ4WIbrEKmjiw0CqKlKR3Bw4xNSpZj14ajP7JYUY/xHyZQ0paymKnjsOTgjpWi/qgeLZ5t/83Sevu9zUHv8ydOXNho4PcD+HMA3b79tsnupH5L0zSP5s3854zWc3zeeWmEbOyI07HRncoFYrcbGRexKRhg0tokqWYCVGZYuJiHO0vVogxTxlEDZhziY+Ld+NiiUhyPo5RMJGwIs+Ae8Y6QmJwLKI+8MwBxuAgkepSeYLMJElYAwCtpuFGPQyU5Ao8wAEx0hdidSn2K10xlHLjlpC1KexWESwZN6sOgqFqnFlsfXW2137P62PuwZyjFou8Hs5d8znMApSNH7NQj127OJs0/cnnjFzJj36K13qa0siW6/bFWkL4mAIoDrczJot6KLbLYT5TYhVwYzjQCyrERbI5wqLzoN8lPUirKcSupi+IwEN86CpdNvIXcpUgAlQoy0nrkebQhySvR55QsWG50I4Iw6erAGmWjpgAKUj6xSeKZREqDBIgB5bJJOiqpncaym1qy3VQuwdXiGlV1CINhf7XVKx86u9q9szxbf3rpZTawz3cCngtofPT0wu3XZ1b/Q6PVz2R59tPWZZv5TgfM9oj0kDPeGOskUREAUjG/0TKLsWycIcsGLtYzglaU7vZ4rxDffSHFwTT4F9fXSHIkmTPcJMqJFPMkJse2NCvsBGZuXDMhLoeIBWlplCIOMiFWcmkVh3/H4iLMqTInC1JDhpSsAwsk3gVfabI8zeggGYL4C9doMKzCeqv98HK796n1zuDDq4/d9Z1LSSK8ELgvAGhQNPf25nTjqnlD1U9Y13h7njfe6CnsUAEjY3FDJHdasEsiqhCiy5VAmIZwo2eJ5QQzMrwWDVmz3H2IC58km4x7g1IZxBPTcXumSEVwXuQgYfiI1QQcyuK4wtgziKuUwSHpzHL3h0n7OAKYUt90MHmxv3iA8Rf3USXhg7QE97xGT1XYTAkXTJRwNBK3jg4R+rfBq7DeGyytrLX+cqXVvi/rTn3l5MnfHpzPwl7uz1/QQvlFD98+MbPen9N146dsM/tnWpl/YJS5ShtdGQ3SNihunTFrI65zTElGLY4kOVGjGrc2SyITAY19USlP4s3bYtaKpzK9FutSvmkqA7qxXIjv1CdqbGmLxawbT2KyfjzJFvclxCyaq2R+4UiKRKpSRh6EZOevuJuPm/qwYmalZAwiZex4HTFWSb7Qv0UNW5a+WF3vf2elvf4H3cHoE0u/sOPxc++A9HKBe7Hnvzig8RnN+V+5WmfmH2QmO2K0u9Vl5hqLSbJxYS6dFL7fV6ohI6BJqSHlgmSnyEC5bJF9zvFqROohprQcG9EUBrvGWh7MX8Z1CnwFoyKCZZVyMfEtlsVIh46tk4VfcaMl3CpT4+xh4rKKCCh7jqh3itiIIcdEUO7Tgp0PUp9KtgxKMHZu0oGMwmm8lXZv+PjySveL3VHv483e8IFL1e8830E4L6B7974rP9XvXqlzdYNR9q15Zn/cObvPkt6iLE0qJcvQcPUlaRJSQHJAEZAh0ElSJEyKJFWp/Igj8yJ3kIQlji+wXolLmDQ+EcEbNydEJysqvKiiiK/MLE5sZ3GzOQLKt+VIMytRJ8S/M4YKITCElEe3hzd68iFCFmy5N5sKNo7Z2N/HZLzMwuDxnd5obWm1+8W13uAz9aj/579x2zWnjh079opltueCfF5Axw/e/2vTzVE40HDuZqv1G402txpr91lnpnBROWFK+4A46U2bDKLimBcMi7Iulv5j+aZQdVEsxnOYad1L2jItZK7MiCZ7F90B7ybilxStXpKY4D+wjBhxjeNcpAsTgZDKSNmRIKWIrD+VjBUg8shCLZut8Z4BXDZeP42ECIKv+P3MkMks9QcjWlxq/+3i4vpHe0X/z7pPfQjbpy9Ze+xlW+j4BY4csXOP7svW9HBzI3M3q2DerJ0+nDfdPqPMZqVoq9z4Ddoj1HFggSQh2bhNhri8JAJJetzIFo7H6zhzldQqxrM01S2jEQKcZJ3JE4jKXb4SfSi3To5LGeOPRRIq3gD/w7mT2CfZLE9cjwHFsmO5U2Dip2GFSHxkphOAMuvkjTWhVmG43u4//eyZ1qdXl9v/uz3Sxy+Fku98IH5/FnrOsyZ2/tpcCNV85rIbXYZa1exzTuH+YTNW2zLUVQb1F0sgo9JdLssGVyv8r1xlflzc2M3cadrNzu5aiIpErCeFhKgOI6fL3EZc95beJ1ueLCFO09ySfcvMaUrW0jIrVgTyFhNYtjQdcJtl0QRJ4xxPk9EH7LCP9zYTUVxZBz/sD4rTa53BV9bXOn+8uNz9v7T6Eb4v9qv5deEu9wXeFRKmRp4fCiHs11bdZG2+B7czNormjFY5L/uN9+ziAR417hzKReVkQ8StUpijB7oBqPANG0yQjFREJiotUwAjlTaARSIjvVVWLEVln8wKyfwfs1r8+6O2OC6sSAcsij1j0paknmL3kJLyNk0+aDpUdb1elqPTg1Gx2BuWD/er8ouDbvnVlYvYLXQpAX9ZgCJhOqNH01T2t/pgr9VaH3CucdA5c63R6qpM0yxuEkdKN0WqGdUNaW477oSHR+NkKbrTDV50Y1uI8PviiIU/kL4n/+GujwgmZJ+ByDDhDnnFDfRJIiuMI42xo5OkqBy35bkczblrJwkal6vptlZxWAnlTFXTwGtVl0X9dKff/dvesHy8rsK37YR7aLo/e/L48WPju+5eSsDO91ovC9BzX3xm5t9tqabKa+xkYy5z2U6jwn4TwoI25gZt9E6tjDU6aK2V5TJh7G5T2SexMYEm1O6GxDItOZS4Gdt1EjAjamlMIbbvACh6kdFjCqBxWQcXrXFyPGLL6vi49FEaemkXkbBIzBGzWt9TgWGoYf29yqvV3rD4u26n/eVB6Z+Y2OSfXPz5a1ZejXrzxYC9VIBCPWiIVgzRyF+xP9tWh3qP9v4a0uGgMXa/0WbeatrjnNnCd0WIVsoxLhofExVRScgEBBPliGMQkEExIKWPUH7y1nlfQ+qy4+84BLgzA16fherC5jCtF8cDZftIjM3pfi1alBH8qvF3c/uXC10VQu1rrfRoVFWt4bA4XQyqbw6q8J3BoP+NYlieDhPZ2i43137o+H8tY8f2fMb0ivz8UgH6vDd3u5ufn5weqlajsGreGHedVvX1WplbM2d3YgBWKbWJKExlRs9aqzmBSqp7mSeRjkwFQDE+YGAdqHXhtqNyIda3G3Vj4F2KyGyR2AhvIYBCtMW/g0Mn1H4xj2YVH8xYAOUyCNraJERj3Vug4aBYH1X+6dGoerQqy4fLkh6pfPeBxUcunab2UiD8CgF6zls7csRufnTfXNWodjlS+6x1m7PMXqWV2udDuNJavcPiZqy8749b403sTZE9eEJASL9RaLl0K2SZD9kgHGBNdQm9kiypAFEgFi8x0KTB5LSKLa6cEY4jKikghOY70ctSx8GoCj6EsiqL5f6geLTTr745HA6/QTU9roxdPPPoHU++mjXmhQD+ygNKxzTRl/TCwoIdWjVdBGrkeWMhKLunrIrtOtDV2pjtxujZzJrdzrhdGP/UWo1wh1Z0tLzH8uOAZJYZJxZzoUxx0u5C5usr0fmk23owoKndB1B5yYVsK0vTAJJASamSdLzx5ubeGD3qDUat4QAZbPmwL/2j3TI8NBgNjwcTVjcNN3VPnpwdEb06DNCFgJlSigt97Mt+HJzfdXt/Njtjd09N2zAxGIxmB0W92Tq7zaiwreGyg87lAHSS534MbTHazCpSV2qlsjTbyYQFXKul4Hj4WHbbQokHq+RTEGWbaD7z95jcj/LPNOsZ69Gky2VyS0jhYe3rM51B8VS323+wNxx9tZk1nhpR/dTyw3c9+7IvxCv4Aq+Chb7Uuw+KtvzyNE1MT0/pepPNzLbM6i1KhS1K+zmjzZzWeovyNO+s3prlLtPeYDvxrKJgjVO20XAKw7SwugIa2roOMmEuVFLFrJXcgzN1U2DhTPXFJn0shcra+6Ku63ZRVCdHo+KR/rB8qKqqvyvK6nu+2tzeOXuye/z4/T+QcuRCz8APFlCWKR1DhpyGUWj+rUcbvfbmbXlpt9em3kZ12BZC2JbnblMjz7eS0tdR7edYHWBI53k25azJfQi69h58T+aMyZyw7XzPztRvDbUPtfeonQTQUIeqDobHIWu/VFfVWU90ujcYHe/2i/9XF+Fbm7dUj5/45j2tV7oxfaGAne9xP1hAX/DdHdMLCyeyqtqsyi1GV8PuprLfbeazzakp27iy9mqhqOrNWqmm1mFLZtQ2TJgrRZuUoVmnbdNo3ubBI6ZVqB34c60w3OCDlD2SgVWhrsuy1mVRD0dF8a2gCHqfR/vD8jvDbv1Eu3H6GXrscxe1DfN8F/yV/vkPIaDP/8jHNC2cyLbY6WzamUnfqNTKcD1MU76Vatrua3sFKZoirbY57Ks3yiqlpyes25o3TKOsymYgvVUbM2OVKiDV53EVH0pfh8GoqorRsHy29v5bStOjuaYnR9YsnVltduiHMOk534F4DQD6wh/h8OHb3alWuUnnrtnp0USl6pmcqOGLuqDcbJ3I8m0TTdsoq3rC1/6KoPUUJgHRTKtrVdehgu5rWJf1SjEsvhusftLZ8vTqY68+oX4+kC7m569ZQOMNrjb6jLG9d1qvhUk7OTthJqbMjMlUVTWHo3LC19zONBD71L7yCq3O4ApHfq1ujZ5ttaa6F3rnhYu5wK/2Y1/DgP69S6WIjhiiI/45teHRo4a+Numo17PTWTP3mzM72SPSg9r3t+q6/eywOrijGB4/fj/G3F61RvQrBfSPEqAvcY2OaToSFeBfuvgdtK/UxX8lXvf/A65ln94QtgJ+AAAAAElFTkSuQmCC",
        e: 1
      },
      {
        id: "image_2",
        w: 171,
        h: 95,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      },
      {
        id: "image_3",
        w: 33,
        h: 65,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      },
      {
        id: "image_4",
        w: 97,
        h: 76,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      },
      {
        id: "image_5",
        w: 184,
        h: 188,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      },
      {
        id: "image_6",
        w: 180,
        h: 133,
        u: "",
        p:
          "data:image/png;base64,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",
        e: 1
      }
    ],
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 2,
        nm: "OUR_STORY_OBJET_01 copie",
        refId: "image_0",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [18]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1242.5, 1481.5, 0],
                to: [-250, -12, 0],
                ti: [78, 200, 0]
              },
              { t: 121.000004928431, s: [366.5, 809.5, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [50.5, 34.5, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 2,
        nm: "OUR_FRIENDS_OBJET_03 copie",
        refId: "image_1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [-42]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1399, 1811.5, 0],
                to: [-618.667, -254, 0],
                ti: [122.667, 174, 0]
              },
              { t: 121.000004928431, s: [447, 1127.5, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [58, 51.5, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 2,
        nm: "OUR_FRIENDS_OBJET_03",
        refId: "image_2",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [39]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1386.5, 504.5, 0],
                to: [-125.333, -14, 0],
                ti: [173.333, 318, 0]
              },
              { t: 121.000004928431, s: [778.5, 84.5, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [85.5, 47.5, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 2,
        nm: "OUR_STORY_OBJET_09 copie",
        refId: "image_3",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [38]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1125.5, 1720.5, 0],
                to: [-97.333, -65.333, 0],
                ti: [197.333, 409.333, 0]
              },
              { t: 121.000004928431, s: [541.5, 1328.5, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [16.5, 32.5, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 2,
        nm: "OUR_STORY_OBJET_09",
        refId: "image_4",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [38]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1505.5, 1718, 0],
                to: [-70, -42.667, 0],
                ti: [138, 166.667, 0]
              },
              { t: 121.000004928431, s: [1085.5, 1462, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [48.5, 38, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 2,
        nm: "OUR_STORY_OBJET_01 copie 2",
        refId: "image_5",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [23]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1296, 1236, 0],
                to: [-336, -50.667, 0],
                ti: [84, 258.667, 0]
              },
              { t: 121.000004928431, s: [48, 452, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [92, 94, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 2,
        nm: "OUR_STORY_OBJET_01",
        refId: "image_6",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 0,
                s: [-38]
              },
              { t: 121.000004928431, s: [0] }
            ],
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [1320, 765.5, 0],
                to: [-72.667, -48, 0],
                ti: [168.667, 200, 0]
              },
              { t: 121.000004928431, s: [884, 477.5, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [90, 66.5, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      }
    ],
    markers: []
  };
  static swipeArrow = {
    v: "5.6.2",
    fr: 30,
    ip: 0,
    op: 40,
    w: 400,
    h: 400,
    nm: "fleche_apparition",
    ddd: 0,
    assets: [],
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Calque de forme 4",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [298, 98.25, 0], ix: 2 },
          a: { a: 0, k: [-208.5, 628.25, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: { x: 0.298, y: 1 },
                      o: { x: 0.333, y: 0 },
                      t: 25,
                      s: [
                        {
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          v: [
                            [-215.375, 635.875],
                            [-217.375, 634],
                            [-213.375, 637.875]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 30,
                      s: [
                        {
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          v: [
                            [-190, 609.5],
                            [-227, 625],
                            [-205, 647]
                          ],
                          c: true
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Tracé 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "fl",
                c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                o: { a: 0, k: 100, ix: 5 },
                r: 1,
                bm: 0,
                nm: "Fond 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: { a: 0, k: [0, 0], ix: 2 },
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                r: { a: 0, k: 0, ix: 6 },
                o: { a: 0, k: 100, ix: 7 },
                sk: { a: 0, k: 0, ix: 4 },
                sa: { a: 0, k: 0, ix: 5 },
                nm: "Transformer "
              }
            ],
            nm: "Forme 1",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 3300,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Calque de forme 3",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: -45, ix: 10 },
          p: { a: 0, k: [199.149, 197.487, 0], ix: 2 },
          a: { a: 0, k: [-168.354, 803.546, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
          {
            inv: false,
            mode: "a",
            pt: {
              a: 1,
              k: [
                {
                  i: { x: 0.296, y: 1 },
                  o: { x: 0.333, y: 0 },
                  t: 15,
                  s: [
                    {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [-298.354, 801.046],
                        [-298.354, 806.046],
                        [-298.293, 806.08],
                        [-298.293, 801.08]
                      ],
                      c: true
                    }
                  ]
                },
                {
                  t: 25,
                  s: [
                    {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      v: [
                        [-298.354, 801.046],
                        [-298.354, 806.046],
                        [-38.354, 806.046],
                        [-38.354, 801.046]
                      ],
                      c: true
                    }
                  ]
                }
              ],
              ix: 1
            },
            o: { a: 0, k: 100, ix: 3 },
            x: { a: 0, k: 0, ix: 4 },
            nm: "Masque 1"
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: { a: 0, k: [260, 5], ix: 2 },
                p: { a: 0, k: [0, 0], ix: 3 },
                r: { a: 0, k: 0, ix: 4 },
                nm: "Tracé rectangulaire 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "fl",
                c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                o: { a: 0, k: 100, ix: 5 },
                r: 1,
                bm: 0,
                nm: "Fond 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: { a: 0, k: [-168.354, 803.546], ix: 2 },
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                r: { a: 0, k: 0, ix: 6 },
                o: { a: 0, k: 100, ix: 7 },
                sk: { a: 0, k: 0, ix: 4 },
                sa: { a: 0, k: 0, ix: 5 },
                nm: "Transformer "
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 3300,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Calque de forme 1",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [85.492, 310.492, 0], ix: 2 },
          a: { a: 0, k: [-421.008, 841.492, 0], ix: 1 },
          s: { a: 0, k: [100, 100, 100], ix: 6 }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: { a: 0, k: [57.484, 57.484], ix: 2 },
                p: { a: 0, k: [0, 0], ix: 3 },
                nm: "Tracé d'ellipse 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "tm",
                s: {
                  a: 1,
                  k: [
                    {
                      i: { x: [0.297], y: [1] },
                      o: { x: [0.333], y: [0] },
                      t: 0,
                      s: [0]
                    },
                    { t: 15, s: [100] }
                  ],
                  ix: 1
                },
                e: { a: 0, k: 0, ix: 2 },
                o: { a: 0, k: 45, ix: 3 },
                m: 1,
                ix: 2,
                nm: "Réduire les tracés 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
              },
              {
                ty: "st",
                c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                o: { a: 0, k: 100, ix: 4 },
                w: { a: 0, k: 4, ix: 5 },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "Contour 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "tr",
                p: { a: 0, k: [-421.008, 841.492], ix: 2 },
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                r: { a: 0, k: 0, ix: 6 },
                o: { a: 0, k: 100, ix: 7 },
                sk: { a: 0, k: 0, ix: 4 },
                sa: { a: 0, k: 0, ix: 5 },
                nm: "Transformer "
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 3300,
        st: 0,
        bm: 0
      }
    ],
    markers: []
  };
  static tuto1 = {
    v: "5.5.10",
    fr: 29.9700012207031,
    ip: 0,
    op: 1779.00007246016,
    w: 700,
    h: 700,
    nm: "PICTO 3",
    ddd: 0,
    assets: [
      {
        id: "comp_0",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "HAND Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0.486, y: 0.806 },
                    o: { x: 0.321, y: 0 },
                    t: 0,
                    s: [550.332, 410.891, 0],
                    to: [9.583, 0, 0],
                    ti: [11.75, 0, 0]
                  },
                  {
                    i: { x: 0.667, y: 1 },
                    o: { x: 0.514, y: 0.156 },
                    t: 29,
                    s: [607.832, 410.891, 0],
                    to: [-11.75, 0, 0],
                    ti: [6.417, 0, 0]
                  },
                  {
                    i: { x: 0.275, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 79,
                    s: [479.832, 410.891, 0],
                    to: [-6.417, 0, 0],
                    ti: [-14.917, 0, 0]
                  },
                  { t: 117.000004765508, s: [569.332, 410.891, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [58.185, 106.388, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0.623, 1.959],
                          [-2.468, 3.173],
                          [-1.05, -0.378],
                          [-0.303, -0.706],
                          [-5.785, -12.777]
                        ],
                        o: [
                          [-0.994, -3.509],
                          [-2.469, -7.757],
                          [1.439, -1.851],
                          [0.722, 0.26],
                          [0.683, 1.591],
                          [0, 0]
                        ],
                        v: [
                          [-2.498, 17.711],
                          [-7.227, 0.007],
                          [-4.407, -15.861],
                          [-0.357, -17.264],
                          [1.233, -15.724],
                          [9.696, 3.18]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [83.018, 61.786], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0.623, 1.959],
                          [-2.468, 3.173],
                          [-1.05, -0.378],
                          [-0.303, -0.706],
                          [-5.785, -12.777]
                        ],
                        o: [
                          [-0.994, -3.509],
                          [-2.469, -7.757],
                          [1.439, -1.851],
                          [0.722, 0.26],
                          [0.683, 1.591],
                          [0, 0]
                        ],
                        v: [
                          [-2.498, 17.711],
                          [-7.227, 0.007],
                          [-4.407, -15.861],
                          [-0.357, -17.264],
                          [1.233, -15.724],
                          [9.696, 3.18]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [83.018, 61.786], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [2.129, 6.694],
                          [-2.468, 3.173],
                          [-1.05, -0.378],
                          [-0.303, -0.706],
                          [-5.785, -12.777]
                        ],
                        o: [
                          [2.237, -6.821],
                          [-2.469, -7.757],
                          [1.439, -1.851],
                          [0.722, 0.26],
                          [0.683, 1.591],
                          [0, 0]
                        ],
                        v: [
                          [-1.247, 25.343],
                          [-7.227, -7.625],
                          [-4.407, -23.492],
                          [-0.357, -24.896],
                          [1.233, -23.355],
                          [9.696, -4.451]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [83.018, 69.417], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-3.176, 4.555],
                          [-0.347, 0.479],
                          [-0.456, 0.51],
                          [-0.431, 0.079],
                          [-0.433, -0.35],
                          [-0.118, -0.157],
                          [13.398, -13.046],
                          [0.978, 1.259]
                        ],
                        o: [
                          [0.402, -0.576],
                          [1.694, -2.344],
                          [0.292, -0.326],
                          [0.376, -0.068],
                          [0.125, 0.101],
                          [1.058, 1.411],
                          [0, 0],
                          [-3.406, -4.384]
                        ],
                        v: [
                          [-6.169, -5.295],
                          [-5.049, -6.873],
                          [-1.857, -10.956],
                          [-0.748, -11.602],
                          [0.517, -11.278],
                          [0.883, -10.897],
                          [-4.053, 11.67],
                          [-5.896, 9.774]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [21.911, 85.548], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-3.176, 4.555],
                          [-0.347, 0.479],
                          [-0.456, 0.51],
                          [-0.431, 0.079],
                          [-0.433, -0.35],
                          [-0.118, -0.157],
                          [13.398, -13.046],
                          [0.978, 1.259]
                        ],
                        o: [
                          [0.402, -0.576],
                          [1.694, -2.344],
                          [0.292, -0.326],
                          [0.376, -0.068],
                          [0.125, 0.101],
                          [1.058, 1.411],
                          [0, 0],
                          [-3.406, -4.384]
                        ],
                        v: [
                          [-6.169, -5.295],
                          [-5.049, -6.873],
                          [-1.857, -10.956],
                          [-0.748, -11.602],
                          [0.517, -11.278],
                          [0.883, -10.897],
                          [-4.053, 11.67],
                          [-5.896, 9.774]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [21.911, 85.548], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.376, -0.068],
                          [0.292, -0.327],
                          [1.694, -2.345],
                          [0.3, 0.387],
                          [-3.176, 4.554],
                          [-0.387, 0.533],
                          [-0.443, 0.495],
                          [-0.432, 0.079],
                          [-0.382, -0.24],
                          [-0.171, -0.227],
                          [6.828, -9.922]
                        ],
                        o: [
                          [-0.432, 0.079],
                          [-0.456, 0.509],
                          [-0.258, -0.269],
                          [-3.406, -4.385],
                          [0.458, -0.658],
                          [1.609, -2.214],
                          [0.292, -0.327],
                          [0.329, -0.059],
                          [0.181, 0.114],
                          [0.905, 1.207],
                          [-0.432, -0.349]
                        ],
                        v: [
                          [0.253, 6.48],
                          [-0.856, 7.126],
                          [-4.049, 11.209],
                          [-4.895, 10.226],
                          [-5.169, -4.843],
                          [-3.903, -6.624],
                          [-0.856, -10.504],
                          [0.253, -11.15],
                          [1.352, -10.943],
                          [1.883, -10.444],
                          [1.516, 6.803]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [20.911, 67.466], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.376, -0.068],
                          [0.292, -0.327],
                          [1.694, -2.345],
                          [0.3, 0.387],
                          [-3.176, 4.554],
                          [-0.387, 0.533],
                          [-0.443, 0.495],
                          [-0.432, 0.079],
                          [-0.382, -0.24],
                          [-0.171, -0.227],
                          [6.828, -9.922]
                        ],
                        o: [
                          [-0.432, 0.079],
                          [-0.456, 0.509],
                          [-0.258, -0.269],
                          [-3.406, -4.385],
                          [0.458, -0.658],
                          [1.609, -2.214],
                          [0.292, -0.327],
                          [0.329, -0.059],
                          [0.181, 0.114],
                          [0.905, 1.207],
                          [-0.432, -0.349]
                        ],
                        v: [
                          [0.253, 6.48],
                          [-0.856, 7.126],
                          [-4.049, 11.209],
                          [-4.895, 10.226],
                          [-5.169, -4.843],
                          [-3.903, -6.624],
                          [-0.856, -10.504],
                          [0.253, -11.15],
                          [1.352, -10.943],
                          [1.883, -10.444],
                          [1.516, 6.803]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [20.911, 67.466], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.329, -0.06],
                          [0.292, -0.327],
                          [1.609, -2.214],
                          [0.359, 0.461],
                          [-3.176, 4.555],
                          [-0.55, 0.613],
                          [-0.432, 0.078],
                          [-0.529, -0.705],
                          [7.08, -10.061]
                        ],
                        o: [
                          [-0.432, 0.079],
                          [-0.443, 0.495],
                          [-0.291, -0.293],
                          [-3.406, -4.385],
                          [2.367, -3.395],
                          [0.292, -0.327],
                          [0.485, -0.088],
                          [0.912, 1.217],
                          [-0.382, -0.24]
                        ],
                        v: [
                          [0.209, 6.772],
                          [-0.9, 7.418],
                          [-3.947, 11.298],
                          [-4.939, 10.166],
                          [-5.213, -4.904],
                          [-0.9, -10.564],
                          [0.209, -11.21],
                          [1.839, -10.505],
                          [1.308, 6.979]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [20.955, 49.544], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.329, -0.06],
                          [0.292, -0.327],
                          [1.609, -2.214],
                          [0.359, 0.461],
                          [-3.176, 4.555],
                          [-0.55, 0.613],
                          [-0.432, 0.078],
                          [-0.529, -0.705],
                          [7.08, -10.061]
                        ],
                        o: [
                          [-0.432, 0.079],
                          [-0.443, 0.495],
                          [-0.291, -0.293],
                          [-3.406, -4.385],
                          [2.367, -3.395],
                          [0.292, -0.327],
                          [0.485, -0.088],
                          [0.912, 1.217],
                          [-0.382, -0.24]
                        ],
                        v: [
                          [0.209, 6.772],
                          [-0.9, 7.418],
                          [-3.947, 11.298],
                          [-4.939, 10.166],
                          [-5.213, -4.904],
                          [-0.9, -10.564],
                          [0.209, -11.21],
                          [1.839, -10.505],
                          [1.308, 6.979]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [20.955, 49.544], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-540, 327.5],
                          [540, 327.5],
                          [540, -327.5],
                          [-540, -327.5]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-540, -327.5],
                          [540, -327.5],
                          [540, 327.5],
                          [-540, 327.5]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-26, 85.5],
                          [30, 85.5],
                          [30, -8.5],
                          [-26, -8.5]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 40, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [47.853, 22.997], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-27.794, -47.311],
                          [27.407, -47.311],
                          [27.407, 45.584],
                          [-27.794, 45.584]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, -5.421],
                          [0, 0],
                          [-5.743, 0],
                          [0, 0],
                          [0, 5.421],
                          [0, 0],
                          [5.744, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 5.421],
                          [0, 0],
                          [5.744, 0],
                          [0, 0],
                          [0, -5.421],
                          [0, 0],
                          [-5.743, 0]
                        ],
                        v: [
                          [-31.662, -52.679],
                          [-31.662, 52.679],
                          [-21.207, 62.548],
                          [21.206, 62.548],
                          [31.662, 52.679],
                          [31.662, -52.679],
                          [21.206, -62.548],
                          [-21.207, -62.548]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [49.298, 62.798], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 11",
                np: 6,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-43.985, -3.053],
                          [0, 0]
                        ],
                        o: [
                          [-23.89, 23.226],
                          [0, 0]
                        ],
                        v: [
                          [31.853, -10.087],
                          [-31.853, -0.796]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [81.149, 197.137], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 12",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 12,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-43.985, -3.053],
                          [0, 0]
                        ],
                        o: [
                          [-23.89, 23.226],
                          [0, 0]
                        ],
                        v: [
                          [31.853, -10.087],
                          [-31.853, -0.796]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.885999971278, 0.877999997606, 0.827000038297, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [81.149, 197.137], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 13",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 13,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-43.985, -3.053],
                          [0, 0]
                        ],
                        o: [
                          [-23.89, 23.226],
                          [0, 0]
                        ],
                        v: [
                          [31.853, -10.087],
                          [-31.853, -0.796]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [81.149, 197.137], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 14",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 14,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-43.985, -3.053],
                          [0, 0]
                        ],
                        o: [
                          [-23.89, 23.226],
                          [0, 0]
                        ],
                        v: [
                          [31.853, -10.087],
                          [-31.853, -0.796]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [81.149, 197.137], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 15",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 15,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.014, 6.802],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [-2.1, 14.726],
                          [-42.47, -2.655],
                          [24.553, -39.815],
                          [0, 0],
                          [1.907, -4.304],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [45.188, 5.228],
                          [55.251, 40.936],
                          [-8.455, 50.226],
                          [-37.564, -27.011],
                          [-52.237, -45.922],
                          [-39.643, -42.013],
                          [-37.731, -33.118]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [57.751, 146.115], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 16",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 16,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.014, 6.802],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [-2.1, 14.726],
                          [-42.47, -2.655],
                          [24.553, -39.815],
                          [0, 0],
                          [1.907, -4.304],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [45.188, 5.228],
                          [55.251, 40.936],
                          [-8.455, 50.226],
                          [-37.564, -27.011],
                          [-52.237, -45.922],
                          [-39.643, -42.013],
                          [-37.731, -33.118]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [57.751, 146.115], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 17",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 17,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [2.468, 7.757],
                          [-2.467, 3.173],
                          [-1.048, -0.353],
                          [-0.312, -0.727],
                          [-5.814, -12.838],
                          [5.972, -17.916],
                          [0, 0],
                          [11.281, -0.663]
                        ],
                        o: [
                          [4.937, -2.821],
                          [-2.469, -7.758],
                          [1.406, -1.807],
                          [0.749, 0.253],
                          [0.674, 1.57],
                          [21.156, 41.606],
                          [-4.732, 14.192],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-13.222, -18.533],
                          [-17.805, -53.792],
                          [-14.985, -69.659],
                          [-11.013, -71.091],
                          [-9.354, -69.545],
                          [-0.882, -50.619],
                          [10.115, 32.314],
                          [19.406, 71.466],
                          [-0.503, 70.802]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [93.596, 115.584], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 18",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 18,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [2.468, 7.757],
                          [-2.467, 3.173],
                          [-1.048, -0.353],
                          [-0.312, -0.727],
                          [-5.814, -12.838],
                          [5.972, -17.916],
                          [0, 0],
                          [11.281, -0.663]
                        ],
                        o: [
                          [4.937, -2.821],
                          [-2.469, -7.758],
                          [1.406, -1.807],
                          [0.749, 0.253],
                          [0.674, 1.57],
                          [21.156, 41.606],
                          [-4.732, 14.192],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-13.222, -18.533],
                          [-17.805, -53.792],
                          [-14.985, -69.659],
                          [-11.013, -71.091],
                          [-9.354, -69.545],
                          [-0.882, -50.619],
                          [10.115, 32.314],
                          [19.406, 71.466],
                          [-0.503, 70.802]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [93.596, 115.584], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 19",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 19,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-4.142, 22.017],
                          [2.978, 2.711],
                          [3.928, -1.785],
                          [0, 0],
                          [-0.169, -5.919],
                          [0.508, -1.694],
                          [0, 0],
                          [1.908, -4.304],
                          [0, 0],
                          [-8.243, -7.454],
                          [-0.452, -0.519],
                          [-1.505, -1.251],
                          [0, -13.439],
                          [0.837, -3.999],
                          [-0.589, -0.965],
                          [-1.649, 0.166],
                          [-16.922, -2.267]
                        ],
                        o: [
                          [0.576, -3.063],
                          [-3.333, -3.036],
                          [0, 0],
                          [-1.509, 5.635],
                          [-11.42, -3.398],
                          [0, 0],
                          [0, 0],
                          [-3.014, 6.802],
                          [0, 0],
                          [0.357, 0.595],
                          [1.287, 1.472],
                          [7.221, 8.096],
                          [0, 0],
                          [-0.231, 1.107],
                          [0.864, 1.415],
                          [16.987, -1.714],
                          [-2.966, -5.818]
                        ],
                        v: [
                          [45.292, -5.953],
                          [36.576, -41.515],
                          [24.522, -41.38],
                          [24.42, -40.768],
                          [22.568, -26.406],
                          [-29.191, -25.078],
                          [-37.485, -36.691],
                          [-50.08, -40.6],
                          [-35.406, -21.689],
                          [-19.364, -10.34],
                          [-18.145, -8.661],
                          [-13.791, -4.744],
                          [-0.325, 27.677],
                          [0.115, 40.185],
                          [0.238, 43.489],
                          [4.772, 44.725],
                          [53.094, 43.272]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [55.594, 140.793], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 20",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 20,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [1.736, 0.32],
                          [0.923, -1.505],
                          [0.049, -1.111],
                          [0.115, -2.585],
                          [-0.766, -1.582],
                          [-2.475, 0.383],
                          [-1.022, 2.285],
                          [0.738, 2.393]
                        ],
                        o: [
                          [-1.474, -0.974],
                          [-1.738, -0.321],
                          [-0.581, 0.948],
                          [-0.116, 2.585],
                          [-0.078, 1.756],
                          [1.091, 2.254],
                          [2.475, -0.382],
                          [1.023, -2.286],
                          [0, 0]
                        ],
                        v: [
                          [3.749, -8.231],
                          [-0.987, -10.519],
                          [-5.666, -8.808],
                          [-6.362, -5.584],
                          [-6.708, 2.17],
                          [-6.083, 7.347],
                          [0.203, 10.458],
                          [5.826, 5.956],
                          [6.102, -1.39]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [85.15, 90.951], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 21",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 21,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 1779.00007246016,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "IMMEUBLES Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [541.809, 369.051, 0], ix: 2 },
              a: { a: 0, k: [77.898, 47.32, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [13.658, 1.645],
                          [-13.238, 1.541],
                          [-13.237, 1.088],
                          [13.659, 1.193]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.413],
                          [1.265, 0],
                          [0, 0]
                        ],
                        v: [
                          [11.387, 16.843],
                          [6.804, 16.843],
                          [6.804, 11.527],
                          [9.096, 8.97],
                          [11.387, 11.527]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.413],
                          [1.266, 0],
                          [0, 0]
                        ],
                        v: [
                          [2.477, 16.843],
                          [-2.105, 16.843],
                          [-2.105, 11.527],
                          [0.186, 8.97],
                          [2.477, 11.527]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.413],
                          [1.265, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.121, 16.843],
                          [-10.704, 16.843],
                          [-10.704, 11.527],
                          [-8.413, 8.97],
                          [-6.121, 11.527]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.412]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.412],
                          [1.266, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.177, 31.734],
                          [-10.76, 31.734],
                          [-10.76, 26.418],
                          [-8.469, 23.861],
                          [-6.177, 26.418]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 5,
                    ty: "sh",
                    ix: 6,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.413],
                          [1.265, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-10.704, -11.334],
                          [-8.413, -13.892],
                          [-6.121, -11.334],
                          [-6.121, -6.019],
                          [-10.704, -6.019]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 6",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 6,
                    ty: "sh",
                    ix: 7,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.412],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.412],
                          [1.265, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-10.704, -26.436],
                          [-8.413, -28.993],
                          [-6.121, -26.436],
                          [-6.121, -21.12],
                          [-10.704, -21.12]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 7",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 7,
                    ty: "sh",
                    ix: 8,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.413],
                          [1.266, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-2.105, -11.334],
                          [0.186, -13.892],
                          [2.477, -11.334],
                          [2.477, -6.019],
                          [-2.105, -6.019]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 8",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 8,
                    ty: "sh",
                    ix: 9,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.412],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.412],
                          [1.266, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-2.105, -26.436],
                          [0.186, -28.993],
                          [2.477, -26.436],
                          [2.477, -21.12],
                          [-2.105, -21.12]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 9",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 9,
                    ty: "sh",
                    ix: 10,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.413],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.413],
                          [1.265, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [6.804, -11.334],
                          [9.096, -13.892],
                          [11.387, -11.334],
                          [11.387, -6.019],
                          [6.804, -6.019]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 10",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 10,
                    ty: "sh",
                    ix: 11,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.265, 0],
                          [0, -1.412],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.412],
                          [1.265, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [6.804, -26.436],
                          [9.096, -28.993],
                          [11.387, -26.436],
                          [11.387, -21.12],
                          [6.804, -21.12]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 11",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 11,
                    ty: "sh",
                    ix: 12,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.9, 0],
                          [0, -2.134],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -2.134],
                          [1.899, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-16.52, -36.02],
                          [-16.52, 36.02],
                          [1.05, 36.02],
                          [1.05, 27.985],
                          [4.49, 24.121],
                          [7.929, 27.985],
                          [7.929, 36.02],
                          [16.52, 36.02],
                          [16.52, -36.02]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 12",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [130.449, 49.363], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 14,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17.107, -24.407],
                          [-17, -24.407],
                          [-17, -24.859],
                          [17.107, -24.859]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, -12.485],
                          [10.22, -17.631],
                          [12.437, -20.106],
                          [14.655, -17.631],
                          [14.655, -12.485]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, -12.485],
                          [1.896, -17.631],
                          [4.114, -20.106],
                          [6.332, -17.631],
                          [6.332, -12.485]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, -12.485],
                          [-6.225, -17.631],
                          [-4.007, -20.106],
                          [-1.789, -17.631],
                          [-1.789, -12.485]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, -12.485],
                          [-14.548, -17.631],
                          [-12.33, -20.106],
                          [-10.112, -17.631],
                          [-10.112, -12.485]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 5,
                    ty: "sh",
                    ix: 6,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17.107, -7.671],
                          [-17, -7.671],
                          [-17, -8.123],
                          [17.107, -8.123]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 6",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 6,
                    ty: "sh",
                    ix: 7,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, 4.207],
                          [10.22, -0.939],
                          [12.437, -3.414],
                          [14.655, -0.939],
                          [14.655, 4.207]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 7",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 7,
                    ty: "sh",
                    ix: 8,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, 4.207],
                          [1.896, -0.939],
                          [4.114, -3.414],
                          [6.332, -0.939],
                          [6.332, 4.207]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 8",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 8,
                    ty: "sh",
                    ix: 9,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, 4.207],
                          [-6.225, -0.939],
                          [-4.007, -3.414],
                          [-1.789, -0.939],
                          [-1.789, 4.207]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 9",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 9,
                    ty: "sh",
                    ix: 10,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, 4.207],
                          [-14.548, -0.939],
                          [-12.33, -3.414],
                          [-10.112, -0.939],
                          [-10.112, 4.207]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 10",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 10,
                    ty: "sh",
                    ix: 11,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17.107, 9.066],
                          [-17, 9.066],
                          [-17, 8.614],
                          [17.107, 8.614]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 11",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 11,
                    ty: "sh",
                    ix: 12,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.366],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.366],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, 20.899],
                          [10.22, 15.753],
                          [12.437, 13.278],
                          [14.655, 15.753],
                          [14.655, 20.899]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 12",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 12,
                    ty: "sh",
                    ix: 13,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.366],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.366],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, 20.899],
                          [1.896, 15.753],
                          [4.114, 13.278],
                          [6.332, 15.753],
                          [6.332, 20.899]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 13",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 13,
                    ty: "sh",
                    ix: 14,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.366],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.366],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, 20.899],
                          [-6.225, 15.753],
                          [-4.007, 13.278],
                          [-1.789, 15.753],
                          [-1.789, 20.899]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 14",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 14,
                    ty: "sh",
                    ix: 15,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.366],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.366],
                          [1.224, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, 20.899],
                          [-14.548, 15.753],
                          [-12.33, 13.278],
                          [-10.112, 15.753],
                          [-10.112, 20.899]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 15",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 15,
                    ty: "sh",
                    ix: 16,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17.107, 25.803],
                          [-17, 25.803],
                          [-17, 25.351],
                          [17.107, 25.351]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 16",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 16,
                    ty: "sh",
                    ix: 17,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.839, 0],
                          [0, -2.052]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -2.052],
                          [1.839, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.669, 41.412],
                          [8.01, 41.412],
                          [8.01, 33.686],
                          [11.339, 29.971],
                          [14.669, 33.686]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 17",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 17,
                    ty: "sh",
                    ix: 18,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.839, 0],
                          [0, -2.052]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -2.052],
                          [1.839, 0],
                          [0, 0]
                        ],
                        v: [
                          [3.351, 41.412],
                          [-3.308, 41.412],
                          [-3.308, 33.686],
                          [0.022, 29.971],
                          [3.351, 33.686]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 18",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 18,
                    ty: "sh",
                    ix: 19,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.839, 0],
                          [0, -2.052]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -2.052],
                          [1.839, 0],
                          [0, 0]
                        ],
                        v: [
                          [-7.965, 41.412],
                          [-14.624, 41.412],
                          [-14.624, 33.686],
                          [-11.294, 29.971],
                          [-7.965, 33.686]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 19",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 19,
                    ty: "sh",
                    ix: 20,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, -34.323],
                          [-12.33, -36.798],
                          [-10.112, -34.323],
                          [-10.112, -29.177],
                          [-14.548, -29.177]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 20",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 20,
                    ty: "sh",
                    ix: 21,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, -34.323],
                          [-4.007, -36.798],
                          [-1.789, -34.323],
                          [-1.789, -29.177],
                          [-6.225, -29.177]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 21",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 21,
                    ty: "sh",
                    ix: 22,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, -34.323],
                          [4.114, -36.798],
                          [6.332, -34.323],
                          [6.332, -29.177],
                          [1.896, -29.177]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 22",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 22,
                    ty: "sh",
                    ix: 23,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, -34.323],
                          [12.437, -36.798],
                          [14.655, -34.323],
                          [14.655, -29.177],
                          [10.22, -29.177]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 23",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 23,
                    ty: "sh",
                    ix: 24,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-20.292, 41.441],
                          [20.292, 41.441],
                          [20.292, -41.441],
                          [-20.292, -41.441]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 24",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [93.637, 43.941], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 26,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17.107, 8.243],
                          [-17, 8.243],
                          [-17, 7.791],
                          [17.107, 7.791]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.368]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.368],
                          [1.225, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.547, 22.112],
                          [10.111, 22.112],
                          [10.111, 16.967],
                          [12.329, 14.492],
                          [14.547, 16.967]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.839, 0],
                          [0, -2.052]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -2.052],
                          [1.839, 0],
                          [0, 0]
                        ],
                        v: [
                          [3.482, 25.933],
                          [-3.177, 25.933],
                          [-3.177, 18.207],
                          [0.152, 14.492],
                          [3.482, 18.207]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.368]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.368],
                          [1.225, 0],
                          [0, 0]
                        ],
                        v: [
                          [-10.167, 22.112],
                          [-14.602, 22.112],
                          [-14.602, 16.967],
                          [-12.384, 14.492],
                          [-10.167, 16.967]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, -3.691],
                          [-12.33, -6.166],
                          [-10.112, -3.691],
                          [-10.112, 1.454],
                          [-14.548, 1.454]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 5,
                    ty: "sh",
                    ix: 6,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-14.548, -17.495],
                          [-12.33, -19.97],
                          [-10.112, -17.495],
                          [-10.112, -12.349],
                          [-14.548, -12.349]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 6",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 6,
                    ty: "sh",
                    ix: 7,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, -3.691],
                          [-4.007, -6.166],
                          [-1.789, -3.691],
                          [-1.789, 1.454],
                          [-6.225, 1.454]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 7",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 7,
                    ty: "sh",
                    ix: 8,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.225, -17.495],
                          [-4.007, -19.97],
                          [-1.789, -17.495],
                          [-1.789, -12.349],
                          [-6.225, -12.349]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 8",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 8,
                    ty: "sh",
                    ix: 9,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, -3.691],
                          [4.114, -6.166],
                          [6.331, -3.691],
                          [6.331, 1.454],
                          [1.896, 1.454]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 9",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 9,
                    ty: "sh",
                    ix: 10,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.896, -17.495],
                          [4.114, -19.97],
                          [6.331, -17.495],
                          [6.331, -12.349],
                          [1.896, -12.349]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 10",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 10,
                    ty: "sh",
                    ix: 11,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, -3.691],
                          [12.437, -6.166],
                          [14.655, -3.691],
                          [14.655, 1.454],
                          [10.22, 1.454]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 11",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 11,
                    ty: "sh",
                    ix: 12,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.224, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.22, -17.495],
                          [12.437, -19.97],
                          [14.655, -17.495],
                          [14.655, -12.349],
                          [10.22, -12.349]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 12",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 12,
                    ty: "sh",
                    ix: 13,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-20.292, 25.962],
                          [20.292, 25.962],
                          [20.292, -25.962],
                          [-20.292, -25.962]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 13",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [53.053, 59.42], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 15,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-8.584, 1.748],
                          [-8.586, 1.296],
                          [8.52, 1.195],
                          [8.522, 1.646]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.368]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -1.368],
                          [1.224, 0],
                          [0, 0]
                        ],
                        v: [
                          [6.33, 16.451],
                          [1.894, 16.451],
                          [1.894, 11.307],
                          [4.112, 8.831],
                          [6.33, 11.307]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.368],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.368],
                          [1.225, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.43, 16.451],
                          [-6.43, 11.307],
                          [-4.212, 8.831],
                          [-1.994, 11.307],
                          [-1.994, 16.451]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.839, 0],
                          [0, -2.052]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -2.052],
                          [1.838, 0],
                          [0, 0]
                        ],
                        v: [
                          [3.221, 34.686],
                          [-3.438, 34.686],
                          [-3.438, 26.96],
                          [-0.108, 23.245],
                          [3.221, 26.96]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.43, -10.822],
                          [-4.212, -13.298],
                          [-1.994, -10.822],
                          [-1.994, -5.676],
                          [-6.43, -5.676]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 5,
                    ty: "sh",
                    ix: 6,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.225, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-6.43, -25.439],
                          [-4.212, -27.915],
                          [-1.994, -25.439],
                          [-1.994, -20.294],
                          [-6.43, -20.294]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 6",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 6,
                    ty: "sh",
                    ix: 7,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.894, -10.822],
                          [4.112, -13.298],
                          [6.33, -10.822],
                          [6.33, -5.676],
                          [1.894, -5.676]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 7",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 7,
                    ty: "sh",
                    ix: 8,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-1.225, 0],
                          [0, -1.367],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -1.367],
                          [1.224, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [1.894, -25.439],
                          [4.112, -27.915],
                          [6.33, -25.439],
                          [6.33, -20.294],
                          [1.894, -20.294]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 8",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 8,
                    ty: "sh",
                    ix: 9,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-11.967, 34.715],
                          [11.967, 34.715],
                          [11.967, -34.715],
                          [-11.967, -34.715]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 9",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [20.795, 50.666], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 11,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-1.231, 0],
                          [0, -1.373],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -1.373],
                          [1.23, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-2.229, 3.828],
                          [-2.229, -1.342],
                          [0, -3.829],
                          [2.228, -1.342],
                          [2.228, 3.828]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.713999968884, 0.663000009574, 0.388000009574, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [97.883, 44.323], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [73.359, -2.043],
                          [-73.359, -2.043],
                          [-73.359, 2.043],
                          [73.359, 2.043]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [77.899, 87.425], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-77.191, 2.232],
                          [77.191, 2.232],
                          [77.191, -2.232],
                          [-77.191, -2.232]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [77.898, 91.7], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [20, 42],
                          [-20, 42],
                          [-20, -42],
                          [20, -42]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.910000011968, 0.936999990426, 0.976000019148, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [93.089, 44.269], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [17, 36.5],
                          [-17, 36.5],
                          [-17, -36.5],
                          [17, -36.5]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.885999971278, 0.877999997606, 0.827000038297, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [130.089, 49.769], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [20.5, 26],
                          [-20.5, 26],
                          [-20.5, -26],
                          [20.5, -26]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.870999983245, 0.842999985639, 0.630999995213, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [52.589, 60.269], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 1779.00007246016,
            st: 0,
            bm: 0
          }
        ]
      }
    ],
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "picot tuto 1 tel",
        refId: "comp_0",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [-222, 186, 0], ix: 2 },
          a: { a: 0, k: [350, 350, 0], ix: 1 },
          s: { a: 0, k: [292, 292, 100], ix: 6 }
        },
        ao: 0,
        w: 700,
        h: 700,
        ip: 0,
        op: 1779.00007246016,
        st: 0,
        bm: 0
      }
    ],
    markers: []
  };
  static tuto2 = {
    v: "5.5.10",
    fr: 15,
    ip: 0,
    op: 32,
    w: 700,
    h: 700,
    nm: "PICTO 2",
    ddd: 0,
    assets: [
      {
        id: "image_0",
        w: 1,
        h: 1,
        u: "",
        p:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAD0lEQVQYV2NkQAOMpAsAAADuAAUtpgPEAAAAAElFTkSuQmCC",
        e: 1
      },
      {
        id: "comp_0",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "partage reseau Silhouettes",
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 22.523,
                    s: [0]
                  },
                  { t: 29.029029029029, s: [100] }
                ],
                ix: 11
              },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 22.523,
                    s: [566.385, 364.545, 0],
                    to: [0, -1.667, 0],
                    ti: [0, 1.667, 0]
                  },
                  { t: 29.029029029029, s: [566.385, 354.545, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [18.558, 6.26, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [35.904, 7.805],
                          [36.815, 7.805]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.603, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [33.725, 7.805],
                          [34.636, 7.805]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.603, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [35.27, 8.44],
                          [35.27, 9.351]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.603, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [35.27, 6.26],
                          [35.27, 7.171]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.603, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [32.358, 3.942],
                          [33.724, 3.942]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.804, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [29.088, 3.942],
                          [30.455, 3.942]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.804, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [31.406, 4.894],
                          [31.406, 6.26]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.804, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [31.406, 1.624],
                          [31.406, 2.991]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.804, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, -0.333],
                          [-0.111, 0],
                          [0, 0.111],
                          [0.555, 0],
                          [0, -0.556],
                          [-0.111, 0],
                          [0, 0.111],
                          [-0.333, 0]
                        ],
                        o: [
                          [0, 0.111],
                          [0.111, 0],
                          [0, -0.556],
                          [-0.556, 0],
                          [0, 0.111],
                          [0.11, 0],
                          [0, -0.333],
                          [0.333, 0]
                        ],
                        v: [
                          [0.605, 0.403],
                          [0.807, 0.605],
                          [1.008, 0.403],
                          [0.001, -0.605],
                          [-1.008, 0.403],
                          [-0.805, 0.605],
                          [-0.604, 0.403],
                          [0.001, -0.201]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.201, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.178, 5.067], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, -0.333],
                          [-0.111, 0],
                          [0, 0.111],
                          [0.555, 0],
                          [0, -0.556],
                          [-0.111, 0],
                          [0, 0.111],
                          [-0.333, 0]
                        ],
                        o: [
                          [0, 0.111],
                          [0.111, 0],
                          [0, -0.556],
                          [-0.556, 0],
                          [0, 0.111],
                          [0.11, 0],
                          [0, -0.333],
                          [0.333, 0]
                        ],
                        v: [
                          [0.605, 0.403],
                          [0.807, 0.605],
                          [1.008, 0.403],
                          [0.001, -0.605],
                          [-1.008, 0.403],
                          [-0.805, 0.605],
                          [-0.604, 0.403],
                          [0.001, -0.201]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.178, 5.067], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.556, 0],
                          [0, -0.556],
                          [-0.111, 0],
                          [0, 0.111],
                          [-0.334, 0],
                          [0, -0.333],
                          [-0.112, 0],
                          [0, 0.111]
                        ],
                        o: [
                          [-0.556, 0],
                          [0, 0.111],
                          [0.112, 0],
                          [0, -0.333],
                          [0.333, 0],
                          [0, 0.111],
                          [0.111, 0],
                          [0, -0.556]
                        ],
                        v: [
                          [0, -0.605],
                          [-1.008, 0.404],
                          [-0.807, 0.605],
                          [-0.605, 0.404],
                          [0, -0.201],
                          [0.604, 0.404],
                          [0.806, 0.605],
                          [1.008, 0.404]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.201, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [21.403, 5.067], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 11",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.556, 0],
                          [0, -0.556],
                          [-0.111, 0],
                          [0, 0.111],
                          [-0.334, 0],
                          [0, -0.333],
                          [-0.112, 0],
                          [0, 0.111]
                        ],
                        o: [
                          [-0.556, 0],
                          [0, 0.111],
                          [0.112, 0],
                          [0, -0.333],
                          [0.333, 0],
                          [0, 0.111],
                          [0.111, 0],
                          [0, -0.556]
                        ],
                        v: [
                          [0, -0.605],
                          [-1.008, 0.404],
                          [-0.807, 0.605],
                          [-0.605, 0.404],
                          [0, -0.201],
                          [0.604, 0.404],
                          [0.806, 0.605],
                          [1.008, 0.404]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [21.403, 5.067], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 12",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 12,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [2.335, 0],
                          [0, 2.335],
                          [-2.334, 0],
                          [0, -2.334]
                        ],
                        o: [
                          [-2.334, 0],
                          [0, -2.334],
                          [2.335, 0],
                          [0, 2.335]
                        ],
                        v: [
                          [0, 4.233],
                          [-4.233, 0],
                          [0, -4.233],
                          [4.233, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [2.557, 0],
                          [0, -2.556],
                          [-2.556, 0],
                          [0, 2.556]
                        ],
                        o: [
                          [-2.556, 0],
                          [0, 2.556],
                          [2.557, 0],
                          [0, -2.556]
                        ],
                        v: [
                          [0, -4.636],
                          [-4.637, 0],
                          [0, 4.636],
                          [4.637, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.201, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.791, 5.874], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 13",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 13,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [2.335, 0],
                          [0, 2.335],
                          [-2.334, 0],
                          [0, -2.334]
                        ],
                        o: [
                          [-2.334, 0],
                          [0, -2.334],
                          [2.335, 0],
                          [0, 2.335]
                        ],
                        v: [
                          [0, 4.233],
                          [-4.233, 0],
                          [0, -4.233],
                          [4.233, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [2.557, 0],
                          [0, -2.556],
                          [-2.556, 0],
                          [0, 2.556]
                        ],
                        o: [
                          [-2.556, 0],
                          [0, 2.556],
                          [2.557, 0],
                          [0, -2.556]
                        ],
                        v: [
                          [0, -4.636],
                          [-4.637, 0],
                          [0, 4.636],
                          [4.637, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.791, 5.874], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 14",
                np: 6,
                cix: 2,
                bm: 0,
                ix: 14,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.083, 0.074],
                          [0.074, -0.083],
                          [0.637, 0],
                          [0.42, 0.47],
                          [0.083, -0.074],
                          [-0.074, -0.083],
                          [-0.751, 0],
                          [-0.497, 0.555]
                        ],
                        o: [
                          [-0.083, -0.074],
                          [-0.42, 0.47],
                          [-0.637, 0],
                          [-0.076, -0.083],
                          [-0.083, 0.074],
                          [0.497, 0.555],
                          [0.752, 0],
                          [0.074, -0.083]
                        ],
                        v: [
                          [1.949, -0.542],
                          [1.664, -0.526],
                          [0, 0.213],
                          [-1.664, -0.526],
                          [-1.948, -0.542],
                          [-1.964, -0.257],
                          [0, 0.616],
                          [1.965, -0.257]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.201, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.791, 7.475], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 15",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 15,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.083, 0.074],
                          [0.074, -0.083],
                          [0.637, 0],
                          [0.42, 0.47],
                          [0.083, -0.074],
                          [-0.074, -0.083],
                          [-0.751, 0],
                          [-0.497, 0.555]
                        ],
                        o: [
                          [-0.083, -0.074],
                          [-0.42, 0.47],
                          [-0.637, 0],
                          [-0.076, -0.083],
                          [-0.083, 0.074],
                          [0.497, 0.555],
                          [0.752, 0],
                          [0.074, -0.083]
                        ],
                        v: [
                          [1.949, -0.542],
                          [1.664, -0.526],
                          [0, 0.213],
                          [-1.664, -0.526],
                          [-1.948, -0.542],
                          [-1.964, -0.257],
                          [0, 0.616],
                          [1.965, -0.257]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.791, 7.475], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 16",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 16,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.755],
                          [-1.433, 0],
                          [-0.508, -0.6],
                          [-0.785, 0],
                          [0, -1.432],
                          [2.403, -2.124]
                        ],
                        o: [
                          [0, 0],
                          [-2.403, -2.124],
                          [0, -1.432],
                          [0.785, 0],
                          [0.509, -0.6],
                          [1.432, 0],
                          [0, 1.755],
                          [0, 0]
                        ],
                        v: [
                          [0, 4.25],
                          [-0.646, 3.603],
                          [-4.619, -1.709],
                          [-2.078, -4.25],
                          [0, -3.28],
                          [2.079, -4.25],
                          [4.619, -1.709],
                          [0.646, 3.603]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 0.804, ix: 5 },
                    lc: 2,
                    lj: 2,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [6.629, 6.26], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 17",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 17,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -11.5115115115115,
            op: 878.878878878879,
            st: -11.5115115115115,
            bm: 0
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "picto tete Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [556.434, 300.824, 0], ix: 2 },
              a: { a: 0, k: [6.848, 6.848, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 17.518,
                    s: [0, 0, 100]
                  },
                  { t: 24.5245245245245, s: [100, 100, 100] }
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-1.287, 0],
                          [0, 0],
                          [-0.018, -1.283],
                          [1.692, 0],
                          [1.035, 1.174]
                        ],
                        o: [
                          [0, 0],
                          [1.286, 0],
                          [-1.035, 1.174],
                          [-1.693, 0],
                          [0.016, -1.283]
                        ],
                        v: [
                          [-1.885, 1.414],
                          [1.886, 1.414],
                          [4.24, 3.739],
                          [0, 5.656],
                          [-4.239, 3.739]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-1.296, 0],
                          [0, -1.296],
                          [1.296, 0],
                          [0, 1.296]
                        ],
                        o: [
                          [1.296, 0],
                          [0, 1.296],
                          [-1.296, 0],
                          [0, -1.296]
                        ],
                        v: [
                          [0, -4.241],
                          [2.356, -1.885],
                          [0, 0.472],
                          [-2.357, -1.885]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [3.638, 0],
                          [0, -3.638],
                          [-3.638, 0],
                          [0, 3.639]
                        ],
                        o: [
                          [-3.638, 0],
                          [0, 3.639],
                          [3.638, 0],
                          [0, -3.638]
                        ],
                        v: [
                          [0, -6.598],
                          [-6.598, 0],
                          [0, 6.598],
                          [6.598, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [6.848, 6.848], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 7,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -10.5105105105105,
            op: 879.87987987988,
            st: -10.5105105105105,
            bm: 0
          },
          {
            ddd: 0,
            ind: 5,
            ty: 3,
            nm: "resolutio",
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 20.02,
                    s: [0]
                  },
                  { t: 26.5265265265265, s: [100] }
                ],
                ix: 11
              },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 20.02,
                    s: [577.565, 351.686, 0],
                    to: [0, -2.5, 0],
                    ti: [0, 2.5, 0]
                  },
                  { t: 26.5265265265265, s: [577.565, 336.686, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [27.729, 10.818, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            ip: -3.5035035035035,
            op: 886.886886886887,
            st: -3.5035035035035,
            bm: 0
          },
          {
            ddd: 0,
            ind: 6,
            ty: 4,
            nm: "#résolution Silhouettes",
            ln: "r",
            parent: 5,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 20.02,
                    s: [0]
                  },
                  { t: 26.5265265265265, s: [100] }
                ],
                ix: 11
              },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-0.087, 17.132, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [52, 52, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [16.121, -17.695],
                          [13.729, -17.695],
                          [14.728, -23.689],
                          [11.564, -23.689],
                          [10.596, -17.695],
                          [8.098, -17.695],
                          [9.052, -23.689],
                          [5.918, -23.689],
                          [4.965, -17.695],
                          [1.801, -17.695],
                          [1.801, -14.819],
                          [4.496, -14.819],
                          [3.527, -8.81],
                          [0.711, -8.81],
                          [0.711, -5.918],
                          [3.073, -5.918],
                          [2.104, 0],
                          [5.268, 0],
                          [6.206, -5.918],
                          [8.704, -5.918],
                          [7.75, 0],
                          [10.883, 0],
                          [11.837, -5.918],
                          [15.031, -5.918],
                          [15.031, -8.81],
                          [12.306, -8.81],
                          [13.275, -14.819],
                          [16.121, -14.819]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "#",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [9.173, -8.81],
                          [6.66, -8.81],
                          [7.629, -14.819],
                          [10.142, -14.819]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "#",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "#",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.216, 0.6],
                          [0, 0.696],
                          [0, 0],
                          [0.144, 0.504],
                          [0.336, 0.384],
                          [0.528, 0.216],
                          [0.792, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.528, -0.384],
                          [0.216, -0.6],
                          [0, 0],
                          [0, -0.576],
                          [-0.144, -0.504],
                          [-0.336, -0.384],
                          [-0.528, -0.216],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [20.51, 0],
                          [20.51, -10.512],
                          [21.266, -10.512],
                          [22.562, 0],
                          [25.73, 0],
                          [24.29, -11.304],
                          [25.406, -12.78],
                          [25.73, -14.724],
                          [25.73, -21.024],
                          [25.514, -22.644],
                          [24.794, -23.976],
                          [23.498, -24.876],
                          [21.518, -25.2],
                          [17.342, -25.2],
                          [17.342, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "r",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-0.144, -0.204],
                          [0, -0.288],
                          [0, 0],
                          [0.144, -0.204],
                          [0.408, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0.408, 0],
                          [0.144, 0.204],
                          [0, 0],
                          [0, 0.288],
                          [-0.144, 0.204],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [21.518, -22.068],
                          [22.346, -21.762],
                          [22.562, -21.024],
                          [22.562, -14.724],
                          [22.346, -13.986],
                          [21.518, -13.68],
                          [20.51, -13.68],
                          [20.51, -22.068]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "r",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "r",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [32.93, -10.512],
                          [32.93, -13.644],
                          [29.798, -13.644],
                          [29.798, -22.068],
                          [32.93, -22.068],
                          [32.93, -25.236],
                          [26.63, -25.236],
                          [26.63, 0],
                          [32.93, 0],
                          [32.93, -3.168],
                          [29.798, -3.168],
                          [29.798, -10.512]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "é",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [29.546, -30.456],
                          [27.962, -27.36],
                          [30.266, -27.36],
                          [31.994, -30.456]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "é",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "é",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-0.264, -0.696],
                          [-0.384, -0.636],
                          [-0.456, -0.612],
                          [-0.384, -0.636],
                          [-0.264, -0.696],
                          [0, -0.816],
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792],
                          [0, 0],
                          [0.54, 1.164],
                          [0.66, 0.912],
                          [0.54, 0.792],
                          [0, 0.864],
                          [0, 0],
                          [-0.204, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.504, 0.144],
                          [0.576, 0],
                          [0.516, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, -0.792]
                        ],
                        o: [
                          [0, 0.816],
                          [0.264, 0.696],
                          [0.384, 0.636],
                          [0.456, 0.612],
                          [0.384, 0.636],
                          [0.264, 0.696],
                          [0, 0],
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0],
                          [0, -1.584],
                          [-0.54, -1.164],
                          [-0.66, -0.912],
                          [-0.54, -0.792],
                          [0, 0],
                          [0, -0.408],
                          [0.204, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.792],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.504, -0.144],
                          [-0.576, 0],
                          [-0.516, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0]
                        ],
                        v: [
                          [34.009, -18.9],
                          [34.405, -16.632],
                          [35.377, -14.634],
                          [36.637, -12.762],
                          [37.897, -10.89],
                          [38.869, -8.892],
                          [39.265, -6.624],
                          [39.265, -4.032],
                          [38.959, -3.204],
                          [38.221, -2.988],
                          [37.483, -3.204],
                          [37.177, -4.032],
                          [37.177, -7.344],
                          [34.009, -7.344],
                          [34.009, -4.032],
                          [34.333, -2.034],
                          [35.233, -0.738],
                          [36.583, -0.036],
                          [38.221, 0.18],
                          [39.841, -0.036],
                          [41.173, -0.738],
                          [42.073, -2.034],
                          [42.397, -4.032],
                          [42.397, -6.624],
                          [41.587, -10.746],
                          [39.787, -13.86],
                          [37.987, -16.416],
                          [37.177, -18.9],
                          [37.177, -21.168],
                          [37.483, -22.014],
                          [38.221, -22.248],
                          [38.959, -22.014],
                          [39.265, -21.168],
                          [39.265, -17.856],
                          [42.397, -17.856],
                          [42.397, -21.168],
                          [42.073, -23.166],
                          [41.173, -24.462],
                          [39.841, -25.164],
                          [38.221, -25.38],
                          [36.583, -25.164],
                          [35.233, -24.462],
                          [34.333, -23.166],
                          [34.009, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "s",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "s",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.516, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792],
                          [0, 0],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.504, 0.144],
                          [0.576, 0]
                        ],
                        o: [
                          [-0.516, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0],
                          [0, -0.792],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.504, -0.144],
                          [-0.576, 0]
                        ],
                        v: [
                          [46.051, -25.164],
                          [44.701, -24.462],
                          [43.801, -23.166],
                          [43.477, -21.168],
                          [43.477, -4.032],
                          [43.801, -2.034],
                          [44.701, -0.738],
                          [46.051, -0.036],
                          [47.689, 0.18],
                          [49.309, -0.036],
                          [50.641, -0.738],
                          [51.541, -2.034],
                          [51.865, -4.032],
                          [51.865, -21.168],
                          [51.541, -23.166],
                          [50.641, -24.462],
                          [49.309, -25.164],
                          [47.689, -25.38]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "o",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-0.204, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408],
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0]
                        ],
                        o: [
                          [0.204, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0],
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, -0.408]
                        ],
                        v: [
                          [46.951, -22.014],
                          [47.689, -22.248],
                          [48.427, -22.014],
                          [48.733, -21.168],
                          [48.733, -4.032],
                          [48.427, -3.204],
                          [47.689, -2.988],
                          [46.951, -3.204],
                          [46.645, -4.032],
                          [46.645, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "o",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "o",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [59.244, 0],
                          [59.244, -3.168],
                          [56.112, -3.168],
                          [56.112, -25.2],
                          [52.944, -25.2],
                          [52.944, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "l",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "l",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0]
                        ],
                        v: [
                          [68.712, -25.164],
                          [65.58, -25.164],
                          [65.58, -4.032],
                          [65.274, -3.204],
                          [64.536, -2.988],
                          [63.798, -3.204],
                          [63.492, -4.032],
                          [63.492, -25.164],
                          [60.324, -25.164],
                          [60.324, -4.032],
                          [60.648, -2.034],
                          [61.548, -0.738],
                          [62.898, -0.036],
                          [64.536, 0.18],
                          [66.156, -0.036],
                          [67.488, -0.738],
                          [68.388, -2.034],
                          [68.712, -4.032]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "u",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "u",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [75.911, -22.068],
                          [79.079, -22.068],
                          [79.079, -25.2],
                          [69.611, -25.2],
                          [69.611, -22.068],
                          [72.779, -22.068],
                          [72.779, 0],
                          [75.911, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "t",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "t",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [82.967, 0],
                          [82.967, -25.2],
                          [79.799, -25.2],
                          [79.799, 0]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "i",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "i",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.516, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792],
                          [0, 0],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.504, 0.144],
                          [0.576, 0]
                        ],
                        o: [
                          [-0.516, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0],
                          [0, -0.792],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.504, -0.144],
                          [-0.576, 0]
                        ],
                        v: [
                          [86.621, -25.164],
                          [85.271, -24.462],
                          [84.371, -23.166],
                          [84.047, -21.168],
                          [84.047, -4.032],
                          [84.371, -2.034],
                          [85.271, -0.738],
                          [86.621, -0.036],
                          [88.259, 0.18],
                          [89.879, -0.036],
                          [91.211, -0.738],
                          [92.111, -2.034],
                          [92.435, -4.032],
                          [92.435, -21.168],
                          [92.111, -23.166],
                          [91.211, -24.462],
                          [89.879, -25.164],
                          [88.259, -25.38]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "o",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-0.204, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408],
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0]
                        ],
                        o: [
                          [0.204, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0],
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, -0.408]
                        ],
                        v: [
                          [87.521, -22.014],
                          [88.259, -22.248],
                          [88.997, -22.014],
                          [89.303, -21.168],
                          [89.303, -4.032],
                          [88.997, -3.204],
                          [88.259, -2.988],
                          [87.521, -3.204],
                          [87.215, -4.032],
                          [87.215, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "o",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "o",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [99.166, -25.2],
                          [93.514, -25.2],
                          [93.514, 0],
                          [96.646, 0],
                          [96.682, -21.708],
                          [99.526, 0],
                          [105.322, 0],
                          [105.322, -25.2],
                          [102.154, -25.2],
                          [102.154, -3.492]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "n",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "n",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 8,
            ty: 4,
            nm: "#2020 Silhouettes",
            ln: "2020",
            parent: 10,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 18.018,
                    s: [0]
                  },
                  { t: 24.5245245245245, s: [100] }
                ],
                ix: 11
              },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-0.086, 17.024, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [52, 52, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [16.121, -17.695],
                          [13.729, -17.695],
                          [14.728, -23.689],
                          [11.564, -23.689],
                          [10.596, -17.695],
                          [8.098, -17.695],
                          [9.052, -23.689],
                          [5.918, -23.689],
                          [4.965, -17.695],
                          [1.801, -17.695],
                          [1.801, -14.819],
                          [4.496, -14.819],
                          [3.527, -8.81],
                          [0.711, -8.81],
                          [0.711, -5.918],
                          [3.073, -5.918],
                          [2.104, 0],
                          [5.268, 0],
                          [6.206, -5.918],
                          [8.704, -5.918],
                          [7.75, 0],
                          [10.883, 0],
                          [11.837, -5.918],
                          [15.031, -5.918],
                          [15.031, -8.81],
                          [12.306, -8.81],
                          [13.275, -14.819],
                          [16.121, -14.819]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "#",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [9.173, -8.81],
                          [6.66, -8.81],
                          [7.629, -14.819],
                          [10.142, -14.819]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "#",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "#",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.264, 0.696],
                          [-0.384, 0.636],
                          [-0.456, 0.612],
                          [-0.384, 0.636],
                          [-0.264, 0.696],
                          [0, 0.816],
                          [0, 0],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.516, -0.144],
                          [0.372, -0.324],
                          [0.228, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.216, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408],
                          [0, 0],
                          [0.54, -0.792],
                          [0.66, -0.924],
                          [0.54, -1.152],
                          [0, -1.584]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.816],
                          [0.264, -0.696],
                          [0.384, -0.636],
                          [0.456, -0.612],
                          [0.384, -0.636],
                          [0.264, -0.696],
                          [0, 0],
                          [0, -0.792],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.516, 0.144],
                          [-0.372, 0.324],
                          [-0.228, 0.54],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.408],
                          [0.216, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0],
                          [0, 0.864],
                          [-0.54, 0.792],
                          [-0.66, 0.924],
                          [-0.54, 1.152],
                          [0, 0]
                        ],
                        v: [
                          [17.378, 0],
                          [25.73, 0],
                          [25.73, -3.168],
                          [20.51, -3.168],
                          [20.51, -6.624],
                          [20.906, -8.892],
                          [21.878, -10.89],
                          [23.138, -12.762],
                          [24.398, -14.634],
                          [25.37, -16.632],
                          [25.766, -18.9],
                          [25.766, -21.168],
                          [25.442, -23.166],
                          [24.542, -24.462],
                          [23.192, -25.164],
                          [21.554, -25.38],
                          [19.916, -25.164],
                          [18.584, -24.462],
                          [17.684, -23.166],
                          [17.342, -21.168],
                          [17.342, -17.856],
                          [20.474, -17.856],
                          [20.474, -21.168],
                          [20.798, -22.014],
                          [21.554, -22.248],
                          [22.292, -22.014],
                          [22.598, -21.168],
                          [22.598, -18.9],
                          [21.788, -16.416],
                          [19.988, -13.842],
                          [18.188, -10.728],
                          [17.378, -6.624]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "2",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.504, 0.144],
                          [0.576, 0],
                          [0.516, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792],
                          [0, 0]
                        ],
                        o: [
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.504, -0.144],
                          [-0.576, 0],
                          [-0.516, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0],
                          [0, -0.792]
                        ],
                        v: [
                          [34.909, -23.166],
                          [34.009, -24.462],
                          [32.677, -25.164],
                          [31.057, -25.38],
                          [29.419, -25.164],
                          [28.069, -24.462],
                          [27.169, -23.166],
                          [26.845, -21.168],
                          [26.845, -4.032],
                          [27.169, -2.034],
                          [28.069, -0.738],
                          [29.419, -0.036],
                          [31.057, 0.18],
                          [32.677, -0.036],
                          [34.009, -0.738],
                          [34.909, -2.034],
                          [35.233, -4.032],
                          [35.233, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "0",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0],
                          [-0.204, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408]
                        ],
                        o: [
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, -0.408],
                          [0.204, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0]
                        ],
                        v: [
                          [32.101, -4.032],
                          [31.795, -3.204],
                          [31.057, -2.988],
                          [30.319, -3.204],
                          [30.013, -4.032],
                          [30.013, -21.168],
                          [30.319, -22.014],
                          [31.057, -22.248],
                          [31.795, -22.014],
                          [32.101, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "0",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "0",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.264, 0.696],
                          [-0.384, 0.636],
                          [-0.456, 0.612],
                          [-0.384, 0.636],
                          [-0.264, 0.696],
                          [0, 0.816],
                          [0, 0],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.516, -0.144],
                          [0.372, -0.324],
                          [0.228, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.216, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408],
                          [0, 0],
                          [0.54, -0.792],
                          [0.66, -0.924],
                          [0.54, -1.152],
                          [0, -1.584]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.816],
                          [0.264, -0.696],
                          [0.384, -0.636],
                          [0.456, -0.612],
                          [0.384, -0.636],
                          [0.264, -0.696],
                          [0, 0],
                          [0, -0.792],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.516, 0.144],
                          [-0.372, 0.324],
                          [-0.228, 0.54],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.408],
                          [0.216, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0],
                          [0, 0.864],
                          [-0.54, 0.792],
                          [-0.66, 0.924],
                          [-0.54, 1.152],
                          [0, 0]
                        ],
                        v: [
                          [36.349, 0],
                          [44.701, 0],
                          [44.701, -3.168],
                          [39.481, -3.168],
                          [39.481, -6.624],
                          [39.877, -8.892],
                          [40.849, -10.89],
                          [42.109, -12.762],
                          [43.369, -14.634],
                          [44.341, -16.632],
                          [44.737, -18.9],
                          [44.737, -21.168],
                          [44.413, -23.166],
                          [43.513, -24.462],
                          [42.163, -25.164],
                          [40.525, -25.38],
                          [38.887, -25.164],
                          [37.555, -24.462],
                          [36.655, -23.166],
                          [36.313, -21.168],
                          [36.313, -17.856],
                          [39.445, -17.856],
                          [39.445, -21.168],
                          [39.769, -22.014],
                          [40.525, -22.248],
                          [41.263, -22.014],
                          [41.569, -21.168],
                          [41.569, -18.9],
                          [40.759, -16.416],
                          [38.959, -13.842],
                          [37.159, -10.728],
                          [36.349, -6.624]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "2",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.504, 0.144],
                          [0.576, 0],
                          [0.516, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, -0.792],
                          [0, 0],
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.516, -0.144],
                          [-0.576, 0],
                          [-0.504, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0.792],
                          [0, 0]
                        ],
                        o: [
                          [-0.216, -0.54],
                          [-0.384, -0.324],
                          [-0.504, -0.144],
                          [-0.576, 0],
                          [-0.516, 0.144],
                          [-0.384, 0.324],
                          [-0.216, 0.54],
                          [0, 0],
                          [0, 0.792],
                          [0.216, 0.54],
                          [0.384, 0.324],
                          [0.516, 0.144],
                          [0.576, 0],
                          [0.504, -0.144],
                          [0.384, -0.324],
                          [0.216, -0.54],
                          [0, 0],
                          [0, -0.792]
                        ],
                        v: [
                          [53.881, -23.166],
                          [52.981, -24.462],
                          [51.649, -25.164],
                          [50.029, -25.38],
                          [48.391, -25.164],
                          [47.041, -24.462],
                          [46.141, -23.166],
                          [45.817, -21.168],
                          [45.817, -4.032],
                          [46.141, -2.034],
                          [47.041, -0.738],
                          [48.391, -0.036],
                          [50.029, 0.18],
                          [51.649, -0.036],
                          [52.981, -0.738],
                          [53.881, -2.034],
                          [54.205, -4.032],
                          [54.205, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "0",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0.204, -0.144],
                          [0.288, 0],
                          [0.204, 0.144],
                          [0, 0.408],
                          [0, 0],
                          [-0.204, 0.156],
                          [-0.288, 0],
                          [-0.204, -0.156],
                          [0, -0.408]
                        ],
                        o: [
                          [0, 0.408],
                          [-0.204, 0.144],
                          [-0.288, 0],
                          [-0.204, -0.144],
                          [0, 0],
                          [0, -0.408],
                          [0.204, -0.156],
                          [0.288, 0],
                          [0.204, 0.156],
                          [0, 0]
                        ],
                        v: [
                          [51.073, -4.032],
                          [50.767, -3.204],
                          [50.029, -2.988],
                          [49.291, -3.204],
                          [48.985, -4.032],
                          [48.985, -21.168],
                          [49.291, -22.014],
                          [50.029, -22.248],
                          [50.767, -22.014],
                          [51.073, -21.168]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "0",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289978027344, 0.764984130859, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "0",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 10,
            ty: 3,
            nm: "2020",
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 18.018,
                    s: [0]
                  },
                  { t: 24.5245245245245, s: [100] }
                ],
                ix: 11
              },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 18.018,
                    s: [563.795, 333.544, 0],
                    to: [0, -2.5, 0],
                    ti: [0, 2.5, 0]
                  },
                  { t: 24.5245245245245, s: [563.795, 318.544, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [13.959, 10.818, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            ip: -5.50550550550551,
            op: 884.884884884885,
            st: -5.50550550550551,
            bm: 0
          },
          {
            ddd: 0,
            ind: 11,
            ty: 2,
            nm: "PICTO_02",
            refId: "image_0",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [0, 655, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 12,
            ty: 4,
            nm: "Calque 14 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [562.382, 385.863, 0], ix: 2 },
              a: { a: 0, k: [38.778, 111.03, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 14.515,
                    s: [0, 0, 100]
                  },
                  { t: 20.02002002002, s: [100, 100, 100] }
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, -5.553]
                        ],
                        o: [
                          [5.554, 0],
                          [0, 0]
                        ],
                        v: [
                          [-5.028, -5.028],
                          [5.028, 5.028]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [98.027, 7.528], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-5.553, 0],
                          [0, 0],
                          [0, -5.553],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [-5.554, 0],
                          [0, 0],
                          [0, -5.553]
                        ],
                        v: [
                          [45.25, -5.028],
                          [-35.194, -5.028],
                          [-45.25, 5.028],
                          [35.194, 5.028]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [47.75, 7.528], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [-5.553, 0],
                          [0, 0],
                          [0, -5.553],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [-5.554, 0],
                          [0, 0],
                          [0, -5.553]
                        ],
                        v: [
                          [45.25, -5.028],
                          [-35.194, -5.028],
                          [-45.25, 5.028],
                          [35.194, 5.028]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.885999971278, 0.877999997606, 0.827000038297, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [47.75, 7.528], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-10.86, 4.826],
                          [10.055, 4.826],
                          [10.86, 4.826],
                          [8.781, -0.449],
                          [3.619, -4.825],
                          [1.206, -4.826],
                          [-8.447, -4.826],
                          [-10.458, -2.01]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [92.597, 7.326], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [1.857, -3.597],
                          [-5.716, 8.56],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.217, 8.661],
                          [14.048, -2.021],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-44.847, -50.905],
                          [-44.847, 29.94],
                          [-14.68, 29.94],
                          [-14.807, 30.839],
                          [-21.473, 50.905],
                          [7.945, 29.967],
                          [7.963, 29.94],
                          [44.445, 29.94],
                          [44.847, -50.905]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [58.207, 62.656], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [1.857, -3.597],
                          [-5.716, 8.56],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.217, 8.661],
                          [14.048, -2.021],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-44.847, -50.905],
                          [-44.847, 29.94],
                          [-14.68, 29.94],
                          [-14.807, 30.839],
                          [-21.473, 50.905],
                          [7.945, 29.967],
                          [7.963, 29.94],
                          [44.445, 29.94],
                          [44.847, -50.905]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [58.207, 62.656], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 14,
            ty: 4,
            nm: "Calque 12 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [571.847, 395.363, 0], ix: 2 },
              a: { a: 0, k: [26.132, 111.28, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 16.016,
                    s: [0, 0, 100]
                  },
                  { t: 21.5215215215215, s: [100, 100, 100] }
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 5.153],
                          [5.574, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -8.986],
                          [-5.575, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-10.86, 2.75],
                          [10.055, 2.75],
                          [10.86, 2.75],
                          [0.798, -7.903],
                          [-8.447, -6.903],
                          [-10.458, -4.087]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [79.154, 8.153], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [1.857, -3.597],
                          [-5.716, 8.56],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.217, 8.661],
                          [14.048, -2.021],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-44.847, -50.905],
                          [-44.847, 29.94],
                          [-14.68, 29.94],
                          [-14.807, 30.839],
                          [-21.473, 50.905],
                          [7.945, 29.967],
                          [7.963, 29.94],
                          [44.445, 29.94],
                          [44.847, -50.905]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [45.097, 61.406], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 16,
            ty: 4,
            nm: "Calque 19 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [542.574, 443.271, 0], ix: 2 },
              a: { a: 0, k: [46.926, 71.545, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.883, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [5.94, -46.888],
                          [5.94, -63.199],
                          [12.97, -71.045],
                          [20.001, -63.199],
                          [20.001, -46.888]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [46.926, 71.545], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.883, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [5.94, -46.888],
                          [5.94, -63.199],
                          [12.97, -71.045],
                          [20.001, -63.199],
                          [20.001, -46.888]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.713999968884, 0.663000009574, 0.388000009574, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [46.926, 71.545], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 18,
            ty: 4,
            nm: "Calque 13 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 40, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [557.546, 378.233, 0], ix: 2 },
              a: { a: 0, k: [49.453, 55.201, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            hasMask: true,
            masksProperties: [
              {
                inv: false,
                mode: "a",
                pt: {
                  a: 1,
                  k: [
                    {
                      i: { x: 0, y: 1 },
                      o: { x: 0.333, y: 0 },
                      t: 13.514,
                      s: [
                        {
                          i: [
                            [0.155, 0],
                            [0, -0.155],
                            [-0.155, 0],
                            [0, 0.155]
                          ],
                          o: [
                            [-0.155, 0],
                            [0, 0.155],
                            [0.155, 0],
                            [0, -0.155]
                          ],
                          v: [
                            [54.907, 54.938],
                            [54.626, 55.219],
                            [54.907, 55.5],
                            [55.188, 55.219]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 30.03003003003,
                      s: [
                        {
                          i: [
                            [31.204, 0],
                            [0, -31.204],
                            [-31.204, 0],
                            [0, 31.204]
                          ],
                          o: [
                            [-31.204, 0],
                            [0, 31.204],
                            [31.204, 0],
                            [0, -31.204]
                          ],
                          v: [
                            [54.907, -1.281],
                            [-1.593, 55.219],
                            [54.907, 111.719],
                            [111.407, 55.219]
                          ],
                          c: true
                        }
                      ]
                    }
                  ],
                  ix: 1
                },
                o: { a: 0, k: 100, ix: 3 },
                x: { a: 0, k: 0, ix: 4 },
                nm: "Masque 1"
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [17.844, 0],
                          [0, -30.487],
                          [-30.487, 0],
                          [-10.465, 13.136]
                        ],
                        o: [
                          [-10.465, -13.136],
                          [-30.488, 0],
                          [0, 30.487],
                          [17.845, 0],
                          [0, 0]
                        ],
                        v: [
                          [49.454, -33.59],
                          [5.719, -55.201],
                          [-49.454, 0],
                          [5.704, 55.202],
                          [49.454, 33.59]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [49.453, 55.202], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 20,
            ty: 4,
            nm: "Calque 11 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [542.505, 409.999, 0], ix: 2 },
              a: { a: 0, k: [64.822, 104.816, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [54.156, -111.133],
                          [-30.241, -111.133]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [32.324, -73.344],
                          [32.324, -89.654],
                          [39.354, -97.5],
                          [46.384, -89.654],
                          [46.384, -73.344]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [5.939, -73.344],
                          [5.939, -89.654],
                          [12.969, -97.5],
                          [20, -89.654],
                          [20, -73.344]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.883, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.882, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-19.801, -73.344],
                          [-19.801, -89.654],
                          [-12.771, -97.5],
                          [-5.741, -89.654],
                          [-5.741, -73.344]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, -4.333],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [3.883, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-39.156, -97.5],
                          [-32.126, -89.654],
                          [-32.126, -73.344],
                          [-46.184, -73.344]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 5,
                    ty: "sh",
                    ix: 6,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [54.156, -58.081],
                          [-53.956, -58.081]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 6",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 6,
                    ty: "sh",
                    ix: 7,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [32.324, -20.432],
                          [32.324, -36.743],
                          [39.354, -44.59],
                          [46.384, -36.743],
                          [46.384, -20.432]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 7",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 7,
                    ty: "sh",
                    ix: 8,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [5.939, -20.432],
                          [5.939, -36.743],
                          [12.969, -44.59],
                          [20, -36.743],
                          [20, -20.432]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 8",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 8,
                    ty: "sh",
                    ix: 9,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.883, 0],
                          [0, -4.333],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.333],
                          [3.882, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-19.801, -20.432],
                          [-19.801, -36.743],
                          [-12.771, -44.59],
                          [-5.741, -36.743],
                          [-5.741, -20.432]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 9",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 9,
                    ty: "sh",
                    ix: 10,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.333],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, -4.333],
                          [3.883, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-46.184, -36.743],
                          [-39.156, -44.59],
                          [-32.126, -36.743],
                          [-32.126, -20.432],
                          [-46.184, -20.432]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 10",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 10,
                    ty: "sh",
                    ix: 11,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [54.156, -5.029],
                          [-53.956, -5.029]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 11",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 11,
                    ty: "sh",
                    ix: 12,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.334],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.334],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [5.939, 32.479],
                          [5.939, 16.169],
                          [12.969, 8.322],
                          [20, 16.169],
                          [20, 32.479]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 12",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 12,
                    ty: "sh",
                    ix: 13,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [-3.883, 0],
                          [0, -4.334],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, -4.334],
                          [3.882, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-19.801, 32.479],
                          [-19.801, 16.169],
                          [-12.771, 8.322],
                          [-5.741, 16.169],
                          [-5.741, 32.479]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 13",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 13,
                    ty: "sh",
                    ix: 14,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [-3.882, 0],
                          [0, -4.334],
                          [0, 0]
                        ],
                        o: [
                          [0, -4.334],
                          [3.883, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-46.184, 16.169],
                          [-39.156, 8.322],
                          [-32.126, 16.169],
                          [-32.126, 32.479]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 14",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 14,
                    ty: "sh",
                    ix: 15,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-64.391, -89.193],
                          [-64.391, 12.185]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 18",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ind: 15,
                    ty: "sh",
                    ix: 16,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [64.253, -28.986],
                          [64.253, 20.851]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 19",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "Fusionner les tracés 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.891, 111.632], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 18,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          }
        ]
      }
    ],
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "tuto2 immeuble",
        refId: "comp_0",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [-236, 294, 0], ix: 2 },
          a: { a: 0, k: [350, 350, 0], ix: 1 },
          s: { a: 0, k: [300, 300, 100], ix: 6 }
        },
        ao: 0,
        w: 700,
        h: 700,
        ip: 0,
        op: 883.39039039039,
        st: -7,
        bm: 0
      }
    ],
    markers: []
  };
  static tuto3 = {
    v: "5.5.10",
    fr: 15,
    ip: 0,
    op: 34,
    w: 700,
    h: 700,
    nm: "PICTO 1",
    ddd: 0,
    assets: [
      {
        id: "comp_0",
        layers: [
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Calque de forme 3",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [494.5, 279.75, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 113.417, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [31.125, 29.5], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 0, 0, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [28.313, 55.125], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [107.287, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -5.00500500500501,
            op: 905.905905905906,
            st: 15.5155155155155,
            bm: 0
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Calque 27 Silhouettes",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 36.036,
                    s: [478.166, 316.926, 0],
                    to: [0, -5.229, 0],
                    ti: [0, 5.229, 0]
                  },
                  { t: 41.5415415415415, s: [478.166, 285.551, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [62.679, 38.568, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 11",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 12",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 12,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 13",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 13,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 14",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 14,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 15",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 15,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 16",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 16,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114],
                          [14.113, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 17",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 17,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -5.00500500500501,
            op: 905.905905905906,
            st: 15.5155155155155,
            bm: 0
          },
          {
            ddd: 0,
            ind: 5,
            ty: 4,
            nm: "Calque 29 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [524.294, 339.265, 0], ix: 2 },
              a: { a: 0, k: [6.317, 10.674, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            ef: [
              {
                ty: 21,
                nm: "Remplir",
                np: 9,
                mn: "ADBE Fill",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 10,
                    nm: "Remplir le masque",
                    mn: "ADBE Fill-0001",
                    ix: 1,
                    v: { a: 0, k: 0, ix: 1 }
                  },
                  {
                    ty: 7,
                    nm: "Tous les masques",
                    mn: "ADBE Fill-0007",
                    ix: 2,
                    v: { a: 0, k: 0, ix: 2 }
                  },
                  {
                    ty: 2,
                    nm: "Couleur",
                    mn: "ADBE Fill-0002",
                    ix: 3,
                    v: {
                      a: 0,
                      k: [0.885986328125, 0.877990722656, 0.826965332031, 1],
                      ix: 3
                    }
                  },
                  {
                    ty: 7,
                    nm: "Inversion",
                    mn: "ADBE Fill-0006",
                    ix: 4,
                    v: { a: 0, k: 0, ix: 4 }
                  },
                  {
                    ty: 0,
                    nm: "Contour progressif horizontal",
                    mn: "ADBE Fill-0003",
                    ix: 5,
                    v: { a: 0, k: 0, ix: 5 }
                  },
                  {
                    ty: 0,
                    nm: "Contour progressif vertical",
                    mn: "ADBE Fill-0004",
                    ix: 6,
                    v: { a: 0, k: 0, ix: 6 }
                  },
                  {
                    ty: 0,
                    nm: "Opacité ",
                    mn: "ADBE Fill-0005",
                    ix: 7,
                    v: { a: 0, k: 1, ix: 7 }
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.351, 0],
                          [0, -3.739]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -3.739],
                          [3.35, 0],
                          [0, 0]
                        ],
                        v: [
                          [6.068, 10.424],
                          [-6.068, 10.424],
                          [-6.068, -3.653],
                          [0, -10.424],
                          [6.068, -3.653]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.764999988032, 0.709999952129, 0.419999994016, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [6.318, 10.675], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 7,
            ty: 4,
            nm: "Calque 28 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [524.293, 339.264, 0], ix: 2 },
              a: { a: 0, k: [14.821, 14.821, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.114, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [14.821, 14.821], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 9,
            ty: 5,
            nm: "?",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.333], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 46.547,
                    s: [50]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 51.552,
                    s: [-10]
                  },
                  { t: 53.053053053053, s: [0] }
                ],
                ix: 10
              },
              p: { a: 0, k: [613.473, 338.697, 0], ix: 2 },
              a: { a: 0, k: [-0.027, -7.553, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.333, 0.333, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 46.547,
                    s: [0, 0, 100]
                  },
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 51.552,
                    s: [110, 110, 100]
                  },
                  { t: 53.053053053053, s: [100, 100, 100] }
                ],
                ix: 6
              }
            },
            ao: 0,
            t: {
              d: {
                k: [
                  {
                    s: {
                      s: 20,
                      f: "CanalBoldRomain",
                      t: "?",
                      j: 2,
                      tr: 20,
                      lh: 24,
                      ls: 0,
                      fc: [0, 0.29, 0.765]
                    },
                    t: 0
                  }
                ]
              },
              p: {},
              m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
              a: []
            },
            ip: 7.50750750750751,
            op: 897.897897897898,
            st: 7.50750750750751,
            bm: 0
          },
          {
            ddd: 0,
            ind: 10,
            ty: 4,
            nm: "Calque de forme 2",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [350, 350, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [44.5, 43.75], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [175.75, -9.375], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: -0.5005005005005,
            bm: 0
          },
          {
            ddd: 0,
            ind: 11,
            ty: 4,
            nm: "PICTO_03 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [565.985, 307.682, 0], ix: 2 },
              a: { a: 0, k: [36.137, 10.682, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 4.519],
                          [-4.519, 0],
                          [0, -4.519]
                        ],
                        o: [
                          [-4.519, 0],
                          [0, -4.519],
                          [4.519, 0],
                          [0, 0]
                        ],
                        v: [
                          [0.001, 8.182],
                          [-8.182, 0],
                          [0.001, -8.182],
                          [8.182, 0]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [61.592, 10.682], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 4.519],
                          [-4.519, 0],
                          [0, -4.519]
                        ],
                        o: [
                          [-4.519, 0],
                          [0, -4.519],
                          [4.519, 0],
                          [0, 0]
                        ],
                        v: [
                          [0.001, 8.182],
                          [-8.182, 0],
                          [0.001, -8.182],
                          [8.182, 0]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [36.137, 10.682], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 4.519],
                          [-4.519, 0],
                          [0, -4.519]
                        ],
                        o: [
                          [-4.519, 0],
                          [0, -4.519],
                          [4.519, 0],
                          [0, 0]
                        ],
                        v: [
                          [0, 8.182],
                          [-8.182, 0],
                          [0, -8.182],
                          [8.182, 0]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [10.682, 10.682], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 12,
            ty: 4,
            nm: "Calque de forme 1",
            td: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [538.875, 323.875, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 113.417, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [31.125, 29.5], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 0, ix: 4 },
                    nm: "Tracé rectangulaire 1",
                    mn: "ADBE Vector Shape - Rect",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 0, 0, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [28.313, 55.125], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [107.287, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Rectangle 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 13,
            ty: 4,
            nm: "Calque 26 Silhouettes",
            tt: 1,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0, y: 1 },
                    o: { x: 0.333, y: 0 },
                    t: 20.521,
                    s: [522.541, 361.051, 0],
                    to: [0, -5.229, 0],
                    ti: [0, 5.229, 0]
                  },
                  { t: 26.026026026026, s: [522.541, 329.676, 0] }
                ],
                ix: 2
              },
              a: { a: 0, k: [62.679, 38.568, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 11",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 12",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 12,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 13",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 13,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 14",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 14,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 15",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 15,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 16",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 16,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114],
                          [14.113, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 17",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 17,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 15,
            ty: 4,
            nm: "Calque 25 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [568.544, 383.015, 0], ix: 2 },
              a: { a: 0, k: [6.317, 10.674, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.351, 0],
                          [0, -3.739]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, -3.739],
                          [3.35, 0],
                          [0, 0]
                        ],
                        v: [
                          [6.068, 10.424],
                          [-6.068, 10.424],
                          [-6.068, -3.653],
                          [0, -10.424],
                          [6.068, -3.653]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.764999988032, 0.709999952129, 0.419999994016, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [6.318, 10.675], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 17,
            ty: 4,
            nm: "Calque 24 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [568.543, 383.014, 0], ix: 2 },
              a: { a: 0, k: [14.821, 14.821, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.114, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [14.821, 14.821], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 19,
            ty: 4,
            nm: "Calque 23 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [586.206, 365.45, 0], ix: 2 },
              a: { a: 0, k: [7.381, 7.643, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            hasMask: true,
            masksProperties: [
              {
                inv: false,
                mode: "a",
                pt: {
                  a: 1,
                  k: [
                    {
                      i: { x: 0, y: 1 },
                      o: { x: 0.333, y: 0 },
                      t: 21.522,
                      s: [
                        {
                          i: [
                            [1.163, 0],
                            [0, -1.09],
                            [-1.163, 0],
                            [0, 1.09]
                          ],
                          o: [
                            [-1.163, 0],
                            [0, 1.09],
                            [1.163, 0],
                            [0, -1.09]
                          ],
                          v: [
                            [1.675, 11.059],
                            [-0.43, 13.032],
                            [1.675, 15.006],
                            [3.78, 13.032]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 27.027027027027,
                      s: [
                        {
                          i: [
                            [7.846, 0],
                            [0, -7.355],
                            [-7.846, 0],
                            [0, 7.355]
                          ],
                          o: [
                            [-7.846, 0],
                            [0, 7.355],
                            [7.846, 0],
                            [0, -7.355]
                          ],
                          v: [
                            [3.017, -1.557],
                            [-11.188, 11.761],
                            [3.017, 25.079],
                            [17.223, 11.761]
                          ],
                          c: true
                        }
                      ]
                    }
                  ],
                  ix: 1
                },
                o: { a: 0, k: 100, ix: 3 },
                x: { a: 0, k: 0, ix: 4 },
                nm: "Masque 1"
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [0.5, 0.5],
                          [0.5, 6.332]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.262, 14.787],
                          [8.431, 14.787]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [2.749, -2.749],
                          [-2.749, 2.749]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [8.789, 5.973], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 6.50650650650651,
            op: 896.896896896897,
            st: 6.50650650650651,
            bm: 0
          },
          {
            ddd: 0,
            ind: 21,
            ty: 4,
            nm: "Calque 22 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [567.541, 361.051, 0], ix: 2 },
              a: { a: 0, k: [62.679, 38.568, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [14.113, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [109.136, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.113],
                          [-14.113, 14.113],
                          [-14.113, -14.113],
                          [14.113, -14.113],
                          [14.113, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 6",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 6,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 7",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 7,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.732],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.732]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.732],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [107.176, 73.069], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 8",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 8,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 9",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 9,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.113],
                          [-14.114, 14.113],
                          [-14.114, -14.113],
                          [14.114, -14.113],
                          [14.114, 10.978]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [108.744, 60.523], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 10",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 10,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 11",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 11,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.731, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.731, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.545, 1.568],
                          [-12.546, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.545, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [62.483, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 12",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 12,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 13",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 13,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.977, 14.114],
                          [-14.114, 14.114],
                          [-14.114, -14.114],
                          [14.114, -14.114],
                          [14.114, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [64.051, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 14",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 14,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 15",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 15,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 1.733],
                          [0, 0],
                          [-1.732, 0],
                          [0, 1.733]
                        ],
                        o: [
                          [0, 0],
                          [-1.732, 0],
                          [0, 0],
                          [0, 1.733],
                          [1.732, 0],
                          [0, 0]
                        ],
                        v: [
                          [12.546, 1.568],
                          [-12.545, 1.568],
                          [-15.682, -1.568],
                          [9.409, -1.568],
                          [12.546, 1.568],
                          [15.682, -1.568]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [18.182, 29.159], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 16",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 16,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [10.978, 14.114],
                          [-14.113, 14.114],
                          [-14.113, -14.114],
                          [14.113, -14.114],
                          [14.113, 10.977]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [19.75, 16.614], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 17",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 17,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 23,
            ty: 4,
            nm: "Calque 21 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [561.44, 365.632, 0], ix: 2 },
              a: { a: 0, k: [82.502, 60.007, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 9.545],
                          [0, 0],
                          [0, 0],
                          [-8.536, 0],
                          [0, 0]
                        ],
                        o: [
                          [-8.535, 0],
                          [0, -0.455],
                          [0, 0],
                          [0, 8.536],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [72.274, 8.637],
                          [56.819, -8.182],
                          [-72.274, -8.182],
                          [-72.274, -6.818],
                          [-56.819, 8.637],
                          [71.365, 8.637]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [74.774, 108.877], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 9.545],
                          [0, 0],
                          [0, 0],
                          [-8.536, 0],
                          [0, 0]
                        ],
                        o: [
                          [-8.535, 0],
                          [0, -0.455],
                          [0, 0],
                          [0, 8.536],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [72.274, 8.637],
                          [56.819, -8.182],
                          [-72.274, -8.182],
                          [-72.274, -6.818],
                          [-56.819, 8.637],
                          [71.365, 8.637]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.885999971278, 0.877999997606, 0.827000038297, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [74.774, 108.877], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [8.535, 0],
                          [0, 9.546],
                          [0, 0],
                          [0, 0],
                          [-8.536, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 8.535],
                          [-8.535, 0],
                          [0, -0.454],
                          [0, 0],
                          [0, 8.535],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-64.663, 40.486],
                          [-64.663, -57.507],
                          [80.001, -57.507],
                          [80.001, 42.052],
                          [64.547, 57.507],
                          [49.092, 40.688],
                          [-80.001, 40.688],
                          [-80.001, 42.052],
                          [-64.546, 57.507],
                          [63.638, 57.507]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [82.502, 60.007], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [8.535, 0],
                          [0, 9.546],
                          [0, 0],
                          [0, 0],
                          [-8.536, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 8.535],
                          [-8.535, 0],
                          [0, -0.454],
                          [0, 0],
                          [0, 8.535],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-64.663, 40.486],
                          [-64.663, -57.507],
                          [80.001, -57.507],
                          [80.001, 42.052],
                          [64.547, 57.507],
                          [49.092, 40.688],
                          [-80.001, 40.688],
                          [-80.001, 42.052],
                          [-64.546, 57.507],
                          [63.638, 57.507]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [82.502, 60.007], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 4",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 4,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [65.863, 8.233],
                          [-65.863, 8.233],
                          [-65.863, -8.233],
                          [65.863, -8.233]
                        ],
                        c: true
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [82.525, 109.136], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 5",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 5,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          },
          {
            ddd: 0,
            ind: 25,
            ty: 4,
            nm: "Calque 20 Silhouettes",
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [575.72, 381.971, 0], ix: 2 },
              a: { a: 0, k: [75.74, 76.324, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [7.377, 0],
                          [14.311, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 10.03],
                          [-7.377, 0],
                          [-21.31, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [65.78, -73.804],
                          [73.22, -61.514],
                          [73.22, 55.483],
                          [59.863, 73.645],
                          [-50.41, 73.804],
                          [-73.22, 48.092],
                          [-58.053, 48.092],
                          [-58.053, 8.029]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "st",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 3
                    },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 1.008, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 10,
                    bm: 0,
                    nm: "Contour 1",
                    mn: "ADBE Vector Graphic - Stroke",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [75.74, 76.324], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [7.377, 0],
                          [14.311, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 10.03],
                          [-7.377, 0],
                          [-21.31, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [65.78, -73.804],
                          [73.22, -61.514],
                          [73.22, 55.483],
                          [59.863, 73.645],
                          [-50.41, 73.804],
                          [-73.22, 48.092],
                          [-58.053, 48.092],
                          [-58.053, 8.029]
                        ],
                        c: false
                      },
                      ix: 2
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0, 0.289999988032, 0.764999988032, 1],
                      ix: 4
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Fond 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: { a: 0, k: [75.74, 76.324], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: "Transformer "
                  }
                ],
                nm: "Groupe 2",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 890.39039039039,
            st: 0,
            bm: 0
          }
        ]
      }
    ],
    fonts: {
      list: [
        {
          fName: "CanalBoldRomain",
          fFamily: "CanalBoldRomain",
          fStyle: "Regular",
          ascent: 75
        }
      ]
    },
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "CALENRIER PICTO",
        refId: "comp_0",
        sr: 1,
        ks: {
          o: { a: 0, k: 100, ix: 11 },
          r: { a: 0, k: 0, ix: 10 },
          p: { a: 0, k: [-296, 250, 0], ix: 2 },
          a: { a: 0, k: [350, 350, 0], ix: 1 },
          s: { a: 0, k: [300, 300, 100], ix: 6 }
        },
        ao: 0,
        w: 700,
        h: 700,
        ip: 0,
        op: 870.37037037037,
        st: -20.02002002002,
        bm: 0
      }
    ],
    markers: [],
    chars: [
      {
        ch: "?",
        size: 20,
        style: "Regular",
        w: 61.5,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -3.323],
                        [5.338, -4.129],
                        [2.417, -1.007],
                        [1.309, -0.504],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.309, 0],
                        [-2.216, 4.129],
                        [0, 1.41],
                        [4.33, 0],
                        [0.302, -5.035],
                        [0, 0],
                        [-5.539, 4.33],
                        [-7.352, 0],
                        [-4.33, -2.518],
                        [-2.216, -4.532]
                      ],
                      o: [
                        [0, 6.848],
                        [-2.014, 1.511],
                        [-0.906, 0.403],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.41, 0.403],
                        [5.841, 0],
                        [0.705, -1.208],
                        [0, -4.33],
                        [-4.23, 0],
                        [0, 0],
                        [0.101, -7.352],
                        [5.035, -3.928],
                        [5.237, 0],
                        [4.532, 2.618],
                        [1.309, 2.921]
                      ],
                      v: [
                        [57.404, -53.979],
                        [49.347, -37.564],
                        [42.7, -33.838],
                        [39.276, -32.529],
                        [39.276, -25.58],
                        [20.847, -25.58],
                        [20.847, -44.916],
                        [24.875, -44.312],
                        [36.96, -50.455],
                        [37.967, -54.382],
                        [30.515, -61.734],
                        [23.767, -54.181],
                        [3.827, -54.181],
                        [12.286, -71.704],
                        [30.917, -77.646],
                        [45.218, -73.92],
                        [55.389, -63.245]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "?",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -3.223],
                        [2.316, -2.316],
                        [3.223, 0],
                        [2.316, 2.316],
                        [0, 3.122],
                        [-6.546, 0],
                        [-2.216, -2.316]
                      ],
                      o: [
                        [0, 3.223],
                        [-2.316, 2.316],
                        [-3.223, 0],
                        [-2.316, -2.316],
                        [0, -6.747],
                        [3.323, 0],
                        [2.316, 2.316]
                      ],
                      v: [
                        [42.297, -9.567],
                        [38.873, -1.309],
                        [30.615, 2.115],
                        [22.357, -1.309],
                        [18.933, -9.467],
                        [30.615, -21.249],
                        [38.873, -17.825]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: "?",
                  mn: "ADBE Vector Shape - Group",
                  hd: false
                }
              ],
              nm: "?",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            }
          ]
        },
        fFamily: "CanalBoldRomain"
      }
    ]
  };
}

export default Anims;
